<template>
  <div>
    <div v-if="StoreDevice && StoreFrontendSettings && d_frdWdm" class="app" :style="f_calculateAppContainerStyle()" @click="f_updateSession()">
      <!-- top menu mode -->
        <div v-if="StoreFrontendSettings && ['1'].indexOf(StoreFrontendSettings.data.menu_type) !== -1 && !StoreDevice.isMobile && d_showAplicationHeader" :style="f_navBarTopMenuStyle()" @click="f_closeSupport()">
          <b-row :style="f_calculateNavbarStyle()">
            <b-col cols="4">
              <div v-if="d_allFlowingText.list.length > 0 && d_allFlowingText.text" style="white-space: nowrap; padding-top: 5px;">
                {{ d_allFlowingText.text.substring(d_allFlowingText.text.length - d_allFlowingText.index, d_allFlowingText.text.length) }}
                <!-- {{ d_allFlowingText.text.length }} -->
                <!-- {{ d_allFlowingText.index }} -->
              </div>
            </b-col>
            <b-col cols="2" style="text-align: right;">
              <b-form-checkbox switch v-if="ClsUser.f_checkUserAuth(['admin', 'website_admin', 'website_edit']) || ($route.meta.client_id && ClsUser.f_checkUserAuth([$route.meta.client_id + '_website_admin', $route.meta.client_id + '_website_edit'],'with_id'))" v-model="d_websiteEditStatus">
                <span style="cursor: pointer;">
                  {{ StoreLangTranslation.data['website_edit'][StoreLang] }}
                </span>
              </b-form-checkbox>
            </b-col>
            <b-col cols="6" style="text-align: right;">


              <b-button size="lg" style="padding: 0px;" variant="white" @click="f_openSearchModal()">
                <div class="shopping-cart-button">
                  <i class="fa fa-search" :style="f_calculateShopcartButtonStyle()"></i>
                </div>
              </b-button>


              <b-dropdown v-if="f_shopVisibilityCheck()" variant="white" style="padding: 0px;" no-caret>
                <template slot="button-content">
                  <span :style="f_calculateSelectedCurrencyStyle()"> {{ d_selectedCurrencyType.label }} </span>
                </template>
                <template v-for="(cur_type, cur_type_index) in StoreCurrencyTypeList.data">
                  <b-dropdown-item @click="f_selectCurrencyType(cur_type)">
                    <i class="fa fa-money"></i> {{ cur_type.label }}
                  </b-dropdown-item>
                </template>
              </b-dropdown>
              <b-button v-if="f_shopVisibilityCheck()" size="lg" style="padding: 0px;" variant="white">
                <div class="shopping-cart-button">
                  <template v-if="d_user && d_user.username">
                    <!-- <a :href="f_createThisRouteHrefLink('user_shoppingcart')"> -->
                    <!-- <span @click="f_goToRoute('', 'user_shoppingcart')" :style="f_calculateShopcartButtonStyle()"> {{ StoreLangTranslation.data['my_shopcart'][StoreLang] }} </span> -->
                    <i class="fa fa-shopping-cart" :style="f_calculateShopcartButtonStyle()" @click="f_goToRoute('', 'user_shoppingcart')"></i>
                    <span class="shopping-cart-count" :style="f_calculateShopcartButtonStyle('count')" @click="f_goToRoute('', 'user_shoppingcart')">{{ f_calculateShopcartBundleCount() }}</span>
                  </template>
                  <template v-else>
                    <!-- <span @click="f_login()"> {{ StoreLangTranslation.data['my_shopcart'][StoreLang] }} </span> -->
                    <i class="fa fa-shopping-cart" @click="f_login()"></i>
                  </template>
                </div>
              </b-button>
              <b-button v-if="f_shopVisibilityCheck() && StoreShopCartOrderList.data.length > 0" size="lg" style="padding: 0px;" variant="white">
                <div class="shopping-cart-button">
                  <!-- <a :href="f_createThisRouteHrefLink('user_shopcart_bundle_order_list')"> -->
                    <span @click="f_goToRoute('', 'user_shopcart_bundle_order_list')" :style="f_calculateShopcartButtonStyle()"> {{ StoreLangTranslation.data['order'][StoreLang] }} </span>
                  <!-- </a> -->
                  <span class="shopping-cart-count" :style="f_calculateShopcartButtonStyle('count')" @click="f_goToRoute('', 'user_shopcart_bundle_order_list')"> {{ f_calculateBundleOrderCount() }} </span>
                </div>
              </b-button>
              <b-dropdown v-if="(StoreFrontendSettings && StoreFrontendSettings.data && StoreFrontendSettings.data.language_change_button_visibility === '1')" variant="white" style="padding: 0px;" no-caret>
                <template slot="button-content">
                  <span :style="f_calculateSelectedLangStyle()"> {{ f_showLanguageName(d_selectedLang) }} </span>
                </template>
                <template v-for="(lang, lang_index) in StoreLangList.data">
                  <b-dropdown-item @click="f_selectLang(lang)">
                    <i class="fa fa-language"></i> {{ f_showLanguageName(lang.label) }}
                  </b-dropdown-item>
                </template>
              </b-dropdown>
              <b-button v-if="d_user && d_user.username" @click="f_logout()" size="lg" style="padding: 0px;" variant="white">
                <i class="fa fa-user-circle" :style="f_calculateUsernameShowStyle()"></i>
                <span v-if="!StoreDevice.isMobile" :style="f_calculateUsernameShowStyle()"> {{ f_showUserName() }} </span>
              </b-button>
              <b-button v-if="!d_user && StoreFrontendSettings && StoreFrontendSettings.data.login_function === '1'" title="Login" @click="f_login()" size="lg" style="padding: 0px; " variant="white">
                <span :style="f_calculateLoginButtonShowStyle()">
                  {{ f_loginButtonName() }}
                </span>
                <!-- {{ StoreLangTranslation.data['login'][StoreLang] }} -->
                <!-- {{ StoreLangTranslation.data['client_portal'][StoreLang] }} -->
                <!-- <img src="@/icon/633951.png" width="40px;" /> -->
              </b-button>
            </b-col>
          </b-row>
          <b-row style="margin: 0px; height: 75px; font-size: 20px; font-weight: 700;">
            <b-col cols="2"> </b-col>
            <b-col cols="2" style="margin-top: 15px;">
              <strong style="cursor: pointer;" @click="f_goToMainPage()">
                <img v-if="StoreFrontendSettings.data.navbar_middle_logo" :src="StoreFrontendSettings.data.navbar_middle_logo" style="height: 50px;" />
              </strong>
              <!-- <span v-if="!StoreDevice.isMobile && StoreFrontendSettings.data.application_name && StoreFrontendSettings.data.application_name[StoreLang]" title="Anasayfa" :style="f_styleNavbarApplicationNameTopMenu()" @click="f_goToMainPage()"> {{ StoreFrontendSettings.data.application_name[StoreLang] }}</span> -->
            </b-col>
            <b-col cols="6" style="padding: 0px; margin-top: 15px;">
              <template v-for="(menu_item, menu_item_index) in StoreMenuData.data.list">
                <!-- <template v-if="f_checkMenuPermission(menu_item) && d_topShowMenuIndexList.indexOf(menu_item_index) !== -1"> -->
                <template v-if="f_checkMenuPermission(menu_item)">
                  <!-- <template v-if="(menu_item.show_in_menu && menu_item.show_in_menu.value === '1') || (menu_item.route_path && menu_item.route_path[StoreLang] === $route.path)"> -->
                  <template v-if="(menu_item.show_in_menu && menu_item.show_in_menu.value === '1')">
                      <template v-if="menu_item.link">
                        <span @click="f_goToThisUrl(menu_item.link[StoreLang])" :style="f_calculateTopMenuItemStyle('parent', menu_item)">
                          <template v-if="menu_item.meta && menu_item.meta.fa_icon">
                            <i :class="menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('parent')"></i>
                          </template>
                          <strong @mouseover="f_menuMouseOver('strong', menu_item_index)" @mouseleave="f_menuMouseLeave()" :style="f_calculateMenuCaptionStyle('parent', menu_item_index)" @click="f_goToThisPage(menu_item)"> {{ menu_item.caption[StoreLang] }} </strong>
                        </span>
                      </template>
                      <template v-else>
                        <template v-if="f_checkMenuShowEligibleFound(menu_item)">
                          <b-dropdown variant="white" style="padding: 3px;" :ref="'menu_item__' + menu_item_index">
                              <template slot="button-content">
                                <template v-if="menu_item.caption[StoreLang].indexOf('</') !== -1">
                                  <!--
                                    <template v-if="menu_item.meta && menu_item.meta.fa_icon">
                                      <i :class="menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('parent')"></i>
                                    </template>
                                  -->
                                  <div :style="f_calculateMenuCaptionStyle('parent')" v-html="menu_item.caption[StoreLang]"></div>
                                </template>
                                <template v-else>
                                  <!--
                                    <template v-if="menu_item.meta && menu_item.meta.fa_icon">
                                      <i :class="menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('parent')"></i>
                                    </template>
                                  -->
                                  <strong @mouseover="f_menuMouseOver('dropdown', menu_item_index)" @mouseleave="f_menuMouseLeave()" :style="f_calculateMenuCaptionStyle('parent', menu_item_index)" @click="f_goToThisPage(menu_item)">
                                    {{ menu_item.caption[StoreLang] }}
                                  </strong>
                                </template>
                              </template>

                              <template v-if="menu_item.list && menu_item.list.length > 0">
                                <template v-for="(sub_menu_item, sub_menu_item_index) in menu_item.list">
                                  <template v-if="f_checkMenuPermission(sub_menu_item)">
                                    <template v-if="(sub_menu_item.show_in_menu && sub_menu_item.show_in_menu.value === '1')">
                                      <template v-if="sub_menu_item.route_path">
                                        <template v-if="f_checkLoginMenuItem(sub_menu_item)">
                                          <!-- <b-dropdown-item :href="f_createHrefLink(sub_menu_item)"> -->
                                          <b-dropdown-item @click="f_goToRoute(sub_menu_item)">
                                              <!-- <i class="fa fa-angle-double-right" style="margin-left: 5px;"></i> -->
                                              <template v-if="sub_menu_item.caption[StoreLang].indexOf('</') !== -1">
                                                <!--
                                                  <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                                    <i :class="sub_menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('child')"></i>
                                                  </template>
                                                -->
                                                <div :style="f_calculateMenuCaptionStyle('child', menu_item_index, sub_menu_item_index)" v-html="sub_menu_item.caption[StoreLang]"></div>
                                              </template>
                                              <template v-else>
                                                <!-- 
                                                  <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                                    <i :class="sub_menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('child')"></i>
                                                  </template>
                                                 -->
                                                <div @mouseover="f_menuMouseOver('dropdown', menu_item_index, sub_menu_item_index)" @mouseleave="f_menuMouseLeave()">
                                                  <strong :style="f_calculateMenuCaptionStyle('child', menu_item_index, sub_menu_item_index)"> {{ sub_menu_item.caption[StoreLang] }} </strong>
                                                </div>
                                              </template>
                                          </b-dropdown-item>
                                        </template>
                                        <template v-else>
                                          <b-dropdown-item @click="f_login()">
                                              <!-- <i class="fa fa-angle-double-right" style="margin-left: 5px;"></i> -->
                                              <template v-if="sub_menu_item.caption[StoreLang].indexOf('</') !== -1">
                                                <!--
                                                  <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                                    <i :class="sub_menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('child')"></i>
                                                  </template>
                                                -->
                                                <div :style="f_calculateMenuCaptionStyle('child', menu_item_index, sub_menu_item_index)" v-html="sub_menu_item.caption[StoreLang]"></div>
                                              </template>
                                              <template v-else>
                                                <!-- 
                                                  <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                                    <i :class="sub_menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('child')"></i>
                                                  </template>
                                                 -->
                                                <strong :style="f_calculateMenuCaptionStyle('child', menu_item_index, sub_menu_item_index)"> {{ sub_menu_item.caption[StoreLang] }} </strong>
                                              </template>
                                          </b-dropdown-item>
                                        </template>
                                      </template>
                                      <template v-else-if="sub_menu_item.link">                                
                                        <b-dropdown-item @click="f_goToThisUrl(sub_menu_item.link[StoreLang])">
                                          <!-- 
                                            <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                              <i :class="sub_menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('child')"></i>
                                            </template>
                                            <i class="fa fa-angle-double-right"></i>
                                           -->
                                            <strong :style="f_calculateMenuCaptionStyle('child', menu_item_index, sub_menu_item_index)"> {{ sub_menu_item.caption[StoreLang] }} </strong>
                                        </b-dropdown-item>
                                      </template>
                                      <template v-else>                                
                                        <b-dropdown-item>
                                            <span v-if="sub_menu_item.caption">
                                              <!-- 
                                                <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                                  <i :class="sub_menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('child')"></i>
                                                </template>
                                                <i class="fa fa-angle-right"></i>
                                               -->
                                              <strong :style="f_calculateMenuCaptionStyle('child', menu_item_index, sub_menu_item_index)"> {{ sub_menu_item.caption[StoreLang] }} </strong>
                                            </span>
                                        </b-dropdown-item>
                                      </template>
                                    </template>
                                  </template>
                                </template>
                              </template>
                          </b-dropdown>
                        </template>
                        <template v-else>
                          <b-button variant="white">
                            <template v-if="menu_item.caption[StoreLang].indexOf('</') !== -1">
                              <!--
                                <template v-if="menu_item.meta && menu_item.meta.fa_icon">
                                  <i :class="menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('parent')"></i>
                                </template>
                              -->
                              <div :style="f_calculateMenuCaptionStyle('parent')" v-html="menu_item.caption[StoreLang]"></div>
                            </template>
                            <template v-else>
                              <!--
                                <template v-if="menu_item.meta && menu_item.meta.fa_icon">
                                  <i :class="menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('parent')"></i>
                                </template>
                              -->
                              <strong @mouseover="f_menuMouseOver('button', menu_item_index)" @mouseleave="f_menuMouseLeave()" :style="f_calculateMenuCaptionStyle('parent', menu_item_index)" @click="f_goToThisPage(menu_item)">
                                {{ menu_item.caption[StoreLang] }}
                              </strong>
                            </template>
                          </b-button>
                        </template>
                      </template>
                      
                  </template>
                </template>
              </template>
              <!-- aşağıdaki alan yanda liste ikonuyla tüm menüleri açıyor. Şimdilik kapattık. Daha sonra gerekirse kullanabiliriz. Ya da bir özellik olarak frontend ayarlarına ekleyebiliriz. -->
              <template v-if="false">
                <b-dropdown variant="white" style="padding: 0px;">
                  <template slot="button-content">
                    <i class="fa fa-th-list"></i>
                  </template>
                  <div style="overflow-x: hidden; overflow-y: auto; height: 500px; font-size: 14px;">
                    <template v-for="(menu_item, menu_item_index) in StoreMenuData.data.list">
                        <template v-if="f_checkMenuPermission(menu_item)">          
                          <template v-if="(menu_item.show_in_menu && menu_item.show_in_menu.value === '1')">
                              <template v-if="menu_item.route_path">
                                  <template v-if="f_checkLoginMenuItem(menu_item)">
                                    <!-- <b-dropdown-item :href="f_createHrefLink(menu_item)"> -->
                                    <b-dropdown-item @click="f_goToRoute(menu_item)">
                                      <template v-if="menu_item.caption[StoreLang].indexOf('</') !== -1">
                                        <template v-if="menu_item.meta && menu_item.meta.fa_icon">
                                          <i :class="menu_item.meta.fa_icon"  :style="f_calculateMenuCaptionStyle('parent')"></i>
                                        </template>
                                        <div :style="f_calculateMenuCaptionStyle('parent')" v-html="menu_item.caption[StoreLang]"></div>
                                      </template>
                                      <template v-else>
                                        <template v-if="menu_item.meta && menu_item.meta.fa_icon">
                                          <i :class="menu_item.meta.fa_icon"  :style="f_calculateMenuCaptionStyle('parent')"></i>
                                        </template>
                                        <strong :style="f_calculateMenuCaptionStyle('parent')"> {{ menu_item.caption[StoreLang] }} </strong>
                                      </template>
                                    </b-dropdown-item>
                                  </template>
                                  <template v-else>
                                    <b-dropdown-item @click="f_login()">
                                      <template v-if="menu_item.caption[StoreLang].indexOf('</') !== -1">
                                        <template v-if="menu_item.meta && menu_item.meta.fa_icon">
                                          <i :class="menu_item.meta.fa_icon"  :style="f_calculateMenuCaptionStyle('parent')"></i>
                                        </template>
                                        <div :style="f_calculateMenuCaptionStyle('parent')" v-html="menu_item.caption[StoreLang]"></div>
                                      </template>
                                      <template v-else>
                                        <template v-if="menu_item.meta && menu_item.meta.fa_icon">
                                          <i :class="menu_item.meta.fa_icon"  :style="f_calculateMenuCaptionStyle('parent')"></i>
                                        </template>
                                        <strong :style="f_calculateMenuCaptionStyle('parent')"> {{ menu_item.caption[StoreLang] }} </strong>
                                      </template>
                                    </b-dropdown-item>
                                  </template>
                                  <template v-if="menu_item.list && menu_item.list.length > 0">
                                    <template v-for="(sub_menu_item, sub_menu_item_index) in menu_item.list">
                                      <template v-if="f_checkMenuPermission(sub_menu_item)">
                                        <template v-if="(sub_menu_item.show_in_menu && sub_menu_item.show_in_menu.value === '1')">
                                          <template v-if="sub_menu_item.route_path">
                                            <template v-if="f_checkLoginMenuItem(sub_menu_item)">
                                              <!-- <b-dropdown-item :href="f_createHrefLink(sub_menu_item)"> -->
                                              <b-dropdown-item @click="f_goToRoute(sub_menu_item)">
                                                  <!-- <i class="fa fa-angle-double-right" style="margin-left: 5px;"></i> -->
                                                  <template v-if="sub_menu_item.caption[StoreLang].indexOf('</') !== -1">
                                                    <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                                      <i :class="sub_menu_item.meta.fa_icon"  :style="f_calculateMenuCaptionStyle('child')"></i>
                                                    </template>
                                                    <div :style="f_calculateMenuCaptionStyle('child')" v-html="sub_menu_item.caption[StoreLang]"></div>
                                                  </template>
                                                  <template v-else>
                                                    <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                                      <i :class="sub_menu_item.meta.fa_icon"  :style="f_calculateMenuCaptionStyle('child')"></i>
                                                    </template>
                                                    <strong :style="f_calculateMenuCaptionStyle('child')"> {{ sub_menu_item.caption[StoreLang] }} </strong>
                                                  </template>
                                              </b-dropdown-item>
                                            </template>
                                            <template v-else>
                                              <b-dropdown-item @click="f_login()">
                                                  <!-- <i class="fa fa-angle-double-right" style="margin-left: 5px;"></i> -->
                                                  <template v-if="sub_menu_item.caption[StoreLang].indexOf('</') !== -1">
                                                    <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                                      <i :class="sub_menu_item.meta.fa_icon"  :style="f_calculateMenuCaptionStyle('child')"></i>
                                                    </template>
                                                    <div :style="f_calculateMenuCaptionStyle('child')" v-html="sub_menu_item.caption[StoreLang]"></div>
                                                  </template>
                                                  <template v-else>
                                                    <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                                      <i :class="sub_menu_item.meta.fa_icon"  :style="f_calculateMenuCaptionStyle('child')"></i>
                                                    </template>
                                                    <strong :style="f_calculateMenuCaptionStyle('child')"> {{ sub_menu_item.caption[StoreLang] }} </strong>
                                                  </template>
                                              </b-dropdown-item>
                                            </template>
                                          </template>
                                          <template v-else-if="sub_menu_item.link">
                                            <b-dropdown-item @click="f_goToThisUrl(sub_menu_item.link[StoreLang])">
                                                <div :style="f_calculateMenuCaptionStyle('child')">
                                                  <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                                    <i :class="sub_menu_item.meta.fa_icon"  :style="f_calculateMenuCaptionStyle('child')"></i>
                                                  </template>
                                                  <i class="fa fa-angle-double-right"></i> {{ sub_menu_item.caption[StoreLang] }}
                                                </div>
                                            </b-dropdown-item>
                                          </template>
                                          <template v-else>
                                            <b-dropdown-item>
                                                <div :style="f_calculateMenuCaptionStyle('child')">
                                                  <span v-if="sub_menu_item.caption">
                                                    <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                                      <i :class="sub_menu_item.meta.fa_icon"  :style="f_calculateMenuCaptionStyle('child')"></i>
                                                    </template>
                                                    <i class="fa fa-angle-right"></i> {{ sub_menu_item.caption[StoreLang] }}
                                                  </span>
                                                </div>
                                            </b-dropdown-item>
                                          </template>
                                        </template>
                                      </template>
                                    </template>
                                  </template>
                              </template>
                              <template v-else-if="menu_item.link">
                                <span @click="f_goToThisUrl(menu_item.link[StoreLang])" :style="f_calculateTopMenuItemStyle('parent', menu_item)">
                                  <template v-if="menu_item.meta && menu_item.meta.fa_icon">
                                    <i :class="menu_item.meta.fa_icon"></i>
                                  </template>
                                  {{ menu_item.caption[StoreLang] }}
                                </span>
                              </template>
                              <template v-else>
                                <span v-if="menu_item.caption" :style="f_calculateTopMenuItemStyle('parent', menu_item)">
                                  <template v-if="menu_item.meta && menu_item.meta.fa_icon">
                                    <i :class="menu_item.meta.fa_icon"></i>
                                  </template>
                                  {{ menu_item.caption[StoreLang] }}
                                </span>
                              </template>
                          </template>
                        </template>
                    </template>
                  </div>
                </b-dropdown>
              </template>
              <b-button variant="outline-primary" style="border-radius: 20px; height: 50px; font-size: 20px;" @click="f_goToContactUsPage()">
                {{ StoreLangTranslation.data['contact_us'][StoreLang] }}
              </b-button>
            </b-col>
            <b-col cols="2">
              
            </b-col>
          </b-row>
        </div>
      <!-- left menu mode -->
      <!-- <div class="app-body" :style="d_showAplicationHeader ? 'margin-bottom: 0px;' : 'margin-top: 0px;'"> -->
      <div :style="d_showAplicationHeader ? 'margin-bottom: 0px; overflow-x: hidden;' : 'margin-top: 0px; overflow-x: hidden;'" @click="f_closeSupport()">
        <div v-if="((['0', '2'].indexOf(StoreFrontendSettings.data.menu_type) !== -1) || StoreDevice.isMobile) && d_showAplicationHeader" class="navbar_class">
          <b-row style="margin: 0px;">
            <b-col cols="5">
              <i class="fa fa-navicon" @click="d_showAplicationSidebar ? d_showAplicationSidebar = false : d_showAplicationSidebar = true" :style="'color: ' + StoreFrontendSettings.data.menu_parent_item_text_color + '; font-weight: 750; font-size: 30px; padding: 5px;'"></i>
              <span v-if="!StoreDevice.isMobile && StoreFrontendSettings.data.application_name && StoreFrontendSettings.data.application_name[StoreLang]" title="Anasayfa" :style="f_styleNavbarApplicationName()" @click="f_goToMainPage()"> {{ StoreFrontendSettings.data.application_name[StoreLang] }}</span>
            </b-col>
            <b-col v-if="!StoreDevice.isMobile" cols="2" style="text-align: center; margin-top: 10px;">
              <strong style="cursor: pointer; font-size: 16px;" @click="f_goToMainPage()">
                <img v-if="StoreFrontendSettings.data.navbar_middle_logo" :src="StoreFrontendSettings.data.navbar_middle_logo" style="height: 2em;" />
              </strong>
            </b-col>
            <b-col v-if="!StoreDevice.isMobile" cols="2" >
              <b-form-checkbox switch v-if="ClsUser.f_checkUserAuth(['admin', 'website_admin', 'website_edit']) || ClsUser.f_checkUserAuth([$route.meta.client_id + '_website_admin', $route.meta.client_id + '_website_edit'],'with_id')" v-model="d_websiteEditStatus">
                <span style="cursor: pointer;">
                  {{ StoreLangTranslation.data['website_edit'][StoreLang] }}
                </span>
              </b-form-checkbox>
            </b-col>
            <b-col :cols="StoreDevice.isMobile ? 7 : 3" style="text-align: right;">
              <b-dropdown v-if="f_shopVisibilityCheck()" variant="white" style="padding: 0px;" no-caret>
                <template slot="button-content">
                  <span :style="f_calculateSelectedCurrencyStyle()"> {{ d_selectedCurrencyType.label }} </span>
                </template>
                <template v-for="(cur_type, cur_type_index) in StoreCurrencyTypeList.data">
                  <b-dropdown-item @click="f_selectCurrencyType(cur_type)">
                    <i class="fa fa-money"></i> {{ cur_type.label }}
                  </b-dropdown-item>
                </template>
              </b-dropdown>
              <b-dropdown v-if="(StoreFrontendSettings && StoreFrontendSettings.data && StoreFrontendSettings.data.language_change_button_visibility === '1')" variant="white" style="padding: 0px; margin-right: 10px;" no-caret>
                <template slot="button-content">
                  <span :style="f_calculateSelectedLangStyle()"> {{ f_showLanguageName(d_selectedLang) }} </span>
                </template>
                <template v-for="(lang, lang_index) in StoreLangList.data">
                  <b-dropdown-item @click="f_selectLang(lang)">
                    <i class="fa fa-language"></i> {{ lang.label }}
                  </b-dropdown-item>
                </template>
              </b-dropdown>
              <b-button v-if="d_user && d_user.username" title="Çıkış Yap" @click="f_logout()" size="lg" style="padding: 0px;" variant="white">
                <i class="fa fa-user"></i>
                <span v-if="!StoreDevice.isMobile"> {{ f_showUserName() }} </span>
              </b-button>
              <b-button v-if="!d_user && StoreFrontendSettings && StoreFrontendSettings.data.login_function === '1'" title="Login" @click="f_login()" size="lg" style="padding: 0px;" variant="white">
                {{ StoreLangTranslation.data['login'][StoreLang] }}
                <!-- <img src="@/icon/633951.png" width="40px;" /> -->
                <i class="fa fa-user-circle-o"></i>
              </b-button>
            </b-col>
          </b-row>
        </div>
        <!-- left menu -->
        <template v-if="StoreDevice.isMobile || (['0', '2'].indexOf(StoreFrontendSettings.data.menu_type) !== -1)">
          <div v-if="d_showAplicationSidebar" :style="f_sideBarStyle()" @click="f_menuAreaClick()">
            <b-row v-if="StoreDevice.isMobile">
              <!-- <b-col cols="12" :style="f_calculateMenuItemStyle('parent', '')"> -->
              <b-col cols="12">
                <!-- 
                  <strong v-if="StoreFrontendSettings.data.menu_top_caption" style="margin: 10px;" @click="f_goToMainPage()">
                    <i class="fa fa-angle-right"></i>
                    {{ StoreFrontendSettings.data.menu_top_caption[StoreLang] }}
                  </strong>
                 -->
                <div @click="f_goToMainPage()" style="margin: 5px;">
                  <img :src="StoreFrontendSettings.data.navbar_middle_logo" style="height: 50px;" />
                </div>
              </b-col>
            </b-row>
            <template v-for="(menu_item, menu_item_index) in StoreMenuData.data.list">
              <template v-if="f_checkMenuPermission(menu_item)">          
                <template v-if="(menu_item.show_in_menu && menu_item.show_in_menu.value === '1')">
                  <b-row v-if="menu_item.caption" :style="f_calculateMenuItemStyle('parent', menu_item)">
                    <template v-if="menu_item.route_path">
                      <template v-if="f_checkLoginMenuItem(menu_item)">
                        <b-col cols="12">
                          <!-- <a :href="f_createHrefLink(menu_item)"> -->
                          <div @click="f_goToRoute(menu_item)">
                            <!-- <i class="fa fa-angle-right"></i> -->
                            <!-- <i class="fa fa-train" style="margin-left: 0px;"></i> -->
                            <!-- <img src="@/icon/2751485.png" style="width: 30px;" /> -->
                            <template v-if="menu_item.caption[StoreLang].indexOf('</') !== -1">
                              <!-- 
                                <template v-if="menu_item.meta && menu_item.meta.fa_icon">
                                  <i :class="menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('parent')"></i>
                                </template>
                               -->
                              <div v-html="menu_item.caption[StoreLang]" :style="f_calculateMenuCaptionStyle('parent')"></div>
                            </template>
                            <template v-else>
                              <!-- 
                                <template v-if="menu_item.meta && menu_item.meta.fa_icon">
                                  <i :class="menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('parent')"></i>
                                </template>
                               -->
                              <span :style="f_calculateMenuCaptionStyle('parent')"> {{ menu_item.caption[StoreLang] }} </span>
                            </template>
                          </div>
                          <!-- <span style="float: right;"> <img v-if="menu_item.login === 1" src="@/icon/9370.png" style="width: 10px;" /> </span> -->
                        </b-col>
                      </template>
                      <template v-else>
                          <div @click="f_login()">
                            <!-- <i class="fa fa-angle-right"></i> -->
                            <!-- <i class="fa fa-train" style="margin-left: 0px;"></i> -->
                            <!-- <img src="@/icon/2751485.png" style="width: 30px;" /> -->
                            <template v-if="menu_item.caption[StoreLang].indexOf('</') !== -1">
                              <!-- 
                                <template v-if="menu_item.meta && menu_item.meta.fa_icon">
                                  <i :class="menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('parent')"></i>
                                </template>
                               -->
                              <div v-html="menu_item.caption[StoreLang]" :style="f_calculateMenuCaptionStyle('parent')"></div>
                            </template>
                            <template v-else>
                              <!-- 
                                <template v-if="menu_item.meta && menu_item.meta.fa_icon">
                                  <i :class="menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('parent')"></i>
                                </template>
                               -->
                              <span :style="f_calculateMenuCaptionStyle('parent')"> {{ menu_item.caption[StoreLang] }} </span>
                            </template>
                          </div>
                          <!-- <span style="float: right;"> <img v-if="menu_item.login === 1" src="@/icon/9370.png" style="width: 10px;" /> </span> -->                      
                      </template>
                    </template>
                    <template v-else-if="menu_item.link">
                      <b-col cols="12" @click="f_goToThisUrl(menu_item.link[StoreLang])">
                        <!-- 
                          <template v-if="menu_item.meta && menu_item.meta.fa_icon">
                            <i :class="menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('parent')"></i>
                          </template>
                          <i class="fa fa-angle-right"></i>
                         -->
                        <span :style="f_calculateMenuCaptionStyle('parent')">                        
                          {{ menu_item.caption[StoreLang] }}
                        </span>
                          <!-- <img src="@/icon/2230573.png" style="width: 30px;" /> -->
                      </b-col>
                    </template>
                    <template v-else>
                      <b-col cols="12">
                        <span v-if="menu_item.caption">
                          <!-- <img src="@/icon/2751485.png" style="width: 30px;" /> -->
                          <!-- <i class="fa fa-angle-right"></i> -->
                          <!-- 
                            <template v-if="menu_item.meta && menu_item.meta.fa_icon">
                              <i :class="menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('parent')"></i>
                            </template>
                           -->
                          <span :style="f_calculateMenuCaptionStyle('parent')">
                            {{ menu_item.caption[StoreLang] }}
                          </span>
                        </span>
                      </b-col>
                    </template>
                  </b-row>
                </template>
                <template v-if="menu_item.list && menu_item.list.length > 0">
                  <template v-for="(sub_menu_item, sub_menu_item_index) in menu_item.list">
                    <template v-if="f_checkMenuPermission(sub_menu_item)">
                      <template v-if="(sub_menu_item.show_in_menu && sub_menu_item.show_in_menu.value === '1')">
                          <b-row :style="f_calculateMenuItemStyle('child', sub_menu_item)">
                            <template v-if="sub_menu_item.route_path">
                              <template v-if="f_checkLoginMenuItem(sub_menu_item)">
                                <b-col cols="12">
                                  <!-- <a :href="f_createHrefLink(sub_menu_item)" :style="StoreFrontendSettings.data.menu_child_item_text_color ? 'color: ' + StoreFrontendSettings.data.menu_child_item_text_color : ''"> -->
                                  <div @click="f_goToRoute(sub_menu_item)" :style="StoreFrontendSettings.data.menu_child_item_text_color ? 'color: ' + StoreFrontendSettings.data.menu_child_item_text_color : ''">
                                    <!-- <i class="fa fa-angle-double-right" style="margin-left: 5px;"></i> -->
                                    <!-- <i class="fa fa-ticket" style="margin-left: 15px;"></i> -->
                                    <!-- <img src="@/icon/2751485.png" style="width: 25px; margin-left: 10px;" /> -->
                                    <template v-if="sub_menu_item.caption[StoreLang].indexOf('</') !== -1">
                                      <!-- 
                                        <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                          <i :class="sub_menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('child')"></i>
                                        </template>
                                       -->
                                      <div v-html="sub_menu_item.caption[StoreLang]" :style="f_calculateMenuCaptionStyle('child')"></div>
                                    </template>
                                    <template v-else>
                                      <!-- 
                                        <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                          <i :class="sub_menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('child')"></i>
                                        </template>
                                       -->
                                      <span :style="f_calculateMenuCaptionStyle('child')"> {{ sub_menu_item.caption[StoreLang] }} </span>
                                    </template>
                                  </div>
                                </b-col>
                              </template>
                              <template v-else>
                                <b-col cols="12">
                                  <div :style="StoreFrontendSettings.data.menu_child_item_text_color ? 'color: ' + StoreFrontendSettings.data.menu_child_item_text_color : ''" @click="f_login()">
                                    <!-- <i class="fa fa-angle-double-right" style="margin-left: 5px;"></i> -->
                                    <!-- <i class="fa fa-ticket" style="margin-left: 15px;"></i> -->
                                    <!-- <img src="@/icon/2751485.png" style="width: 25px; margin-left: 10px;" /> -->
                                    <template v-if="sub_menu_item.caption[StoreLang].indexOf('</') !== -1">
                                      <!-- 
                                        <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                          <i :class="sub_menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('child')"></i>
                                        </template>
                                       -->
                                      <div v-html="sub_menu_item.caption[StoreLang]"></div>
                                    </template>
                                    <template v-else>
                                      <!-- 
                                        <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                          <i :class="sub_menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('child')"></i>
                                        </template>
                                       -->
                                      <span :style="f_calculateMenuCaptionStyle('child')"> {{ sub_menu_item.caption[StoreLang] }} </span>
                                    </template>
                                  </div>
                                </b-col>
                              </template>
                            </template>
                            <template v-else-if="sub_menu_item.link">
                              <b-col cols="12" @click="f_goToThisUrl(sub_menu_item.link[StoreLang])">
                                <!-- 
                                  <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                    <i :class="sub_menu_item.meta.fa_icon"></i>
                                  </template>
                                 -->
                                <i class="fa fa-angle-double-right"></i>
                                {{ sub_menu_item.caption[StoreLang] }}
                                <img src="@/icon/2230573.png" style="width: 30px;" />
                              </b-col>
                            </template>
                            <template v-else>
                              <b-col cols="12">
                                <span v-if="sub_menu_item.caption">
                                  <!-- <img src="@/icon/2751485.png" style="width: 30px;" /> -->
                                  <!-- 
                                    <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                      <i :class="sub_menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('child')"></i>
                                    </template>
                                   -->
                                  <i class="fa fa-angle-right"></i>
                                  <span :style="f_calculateMenuCaptionStyle('child')">
                                    {{ sub_menu_item.caption[StoreLang] }}
                                  </span>
                                </span>
                              </b-col>
                            </template>
                          </b-row>
                        </template>
                    </template>
                  </template>
                </template>
                <div :style="'border-bottom: solid 1px ' + StoreFrontendSettings.data.menu_border_bottom_color + ';'"></div>
              </template>
            </template>
          </div>
        </template>
        <main :style="f_calculateMainAreaStyle()" @click="f_clickMainArea()">
          <div id="router-div">
            <router-view></router-view>
          </div>
            <b-row v-if="d_showAplicationFooter" :style="f_calculateFooterStyle()">
              <b-col cols="2"> </b-col>
              <b-col cols="8" style="padding: 0px;">
                <b-row>
                  <template v-for="(menu_item, menu_item_index) in StoreMenuData.data.list">
                    <template v-if="f_checkMenuPermission(menu_item)">          
                      <template v-if="menu_item.show_in_menu && menu_item.show_in_menu.value === '1'">
                          <template v-if="menu_item.route_path">
                            <b-col sm="12" md="12" lg="4" style="padding: 20px;">
                              <template v-if="f_checkLoginMenuItem(menu_item)">
                                <div @click="f_goToThisPage(menu_item)" style="cursor: pointer;">
                                  <template v-if="menu_item.caption[StoreLang].indexOf('</') !== -1">
                                    <template v-if="menu_item.meta && menu_item.meta.fa_icon">
                                      <i :class="menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('parent', '', '', 'footer')"></i>
                                    </template>
                                    <div v-html="menu_item.caption[StoreLang]" :style="f_calculateMenuCaptionStyle('parent', '', '', 'footer')"></div>
                                  </template>
                                  <template v-else>
                                    <template v-if="menu_item.meta && menu_item.meta.fa_icon">
                                      <i :class="menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('parent', '', '', 'footer')"></i>
                                    </template>
                                    <span :style="f_calculateMenuCaptionStyle('parent', '', '', 'footer')"> {{ menu_item.caption[StoreLang] }} </span>
                                  </template>
                                </div>
                              </template>
                              <template v-else>
                                <div @click="f_login()" style="cursor: pointer;">
                                  <template v-if="menu_item.caption[StoreLang].indexOf('</') !== -1">
                                    <template v-if="menu_item.meta && menu_item.meta.fa_icon">
                                      <i :class="menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('parent', '', '', 'footer')"></i>
                                    </template>
                                    <div v-html="menu_item.caption[StoreLang]" :style="f_calculateMenuCaptionStyle('parent', '', '', 'footer')"></div>
                                  </template>
                                  <template v-else>
                                    <template v-if="menu_item.meta && menu_item.meta.fa_icon">
                                      <i :class="menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('parent', '', '', 'footer')"></i>
                                    </template>
                                    <span :style="f_calculateMenuCaptionStyle('parent', '', '', 'footer')"> {{ menu_item.caption[StoreLang] }} </span>
                                  </template>
                                </div>                            
                              </template>
                              <template v-if="menu_item.list && menu_item.list.length > 0">
                                <template v-for="(sub_menu_item, sub_menu_item_index) in menu_item.list">
                                  <template v-if="f_checkMenuPermission(sub_menu_item)">
                                    <template v-if="(sub_menu_item.show_in_menu && sub_menu_item.show_in_menu.value === '1')">
                                        <template v-if="sub_menu_item.route_path">
                                          <template v-if="f_checkLoginMenuItem(sub_menu_item)">
                                            <div @click="f_goToThisPage(sub_menu_item)" style="cursor: pointer;">
                                              <template v-if="sub_menu_item.caption[StoreLang].indexOf('</') !== -1">
                                                <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                                  <i :class="sub_menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('child', '', '', 'footer')"></i>
                                                </template>
                                                <div v-html="sub_menu_item.caption[StoreLang]" :style="f_calculateMenuCaptionStyle('child', '', '', 'footer')"></div>
                                              </template>
                                              <template v-else>
                                                <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                                  <i :class="sub_menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('child', '', '', 'footer')"></i>
                                                </template>
                                                <span :style="f_calculateMenuCaptionStyle('child', '', '', 'footer')"> {{ sub_menu_item.caption[StoreLang] }} </span>
                                              </template>
                                            </div>
                                          </template>
                                          <template v-else>
                                            <div @click="f_login()" style="cursor: pointer;">
                                              <template v-if="sub_menu_item.caption[StoreLang].indexOf('</') !== -1">
                                                <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                                  <i :class="sub_menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('child', '', '', 'footer')"></i>
                                                </template>
                                                <div v-html="sub_menu_item.caption[StoreLang]" :style="f_calculateMenuCaptionStyle('child', '', '', 'footer')"></div>
                                              </template>
                                              <template v-else>
                                                <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                                  <i :class="sub_menu_item.meta.fa_icon" :style="f_calculateMenuCaptionStyle('child', '', '', 'footer')"></i>
                                                </template>
                                                <span :style="f_calculateMenuCaptionStyle('child', '', '', 'footer')"> {{ sub_menu_item.caption[StoreLang] }} </span>
                                              </template>
                                            </div>
                                          </template>
                                        </template>
                                        <template v-else-if="sub_menu_item.link">
                                          <div @click="f_goToThisUrl(sub_menu_item.link[StoreLang])" style="cursor: pointer;">
                                             <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                               <i :class="sub_menu_item.meta.fa_icon"></i>
                                             </template>
                                             <span :style="f_calculateMenuCaptionStyle('child', '', '', 'footer')">
                                              {{ sub_menu_item.caption[StoreLang] }}
                                             </span>
                                             <img src="@/icon/2230573.png" style="width: 30px;" />
                                          </div>
                                        </template>
                                        <template v-else>
                                          <div style="cursor: pointer;">
                                            <span v-if="sub_menu_item.caption" :style="f_calculateMenuCaptionStyle('child', '', '', 'footer')">
                                              <template v-if="sub_menu_item.meta && sub_menu_item.meta.fa_icon">
                                                <i :class="sub_menu_item.meta.fa_icon"></i>
                                              </template>
                                              {{ sub_menu_item.caption[StoreLang] }}
                                            </span>
                                          </div>
                                        </template>
                                    </template>
                                  </template>
                                </template>
                              </template>
                            </b-col>
                          </template>
                          <template v-else-if="menu_item.link">
                            <span @click="f_goToThisUrl(menu_item.link[StoreLang])" :style="f_calculateMenuCaptionStyle('parent', '', '', 'footer')">
                              <template v-if="menu_item.meta && menu_item.meta.fa_icon">
                                <i :class="menu_item.meta.fa_icon"></i>
                              </template>
                              {{ menu_item.caption[StoreLang] }} <img src="@/icon/2230573.png" style="width: 30px;" />
                            </span>
                          </template>
                          <template v-else>
                            <span v-if="menu_item.caption" :style="f_calculateMenuCaptionStyle('parent', '', '', 'footer')">
                              <template v-if="menu_item.meta && menu_item.meta.fa_icon">
                                <i :class="menu_item.meta.fa_icon"></i>
                              </template>
                              {{ menu_item.caption[StoreLang] }}
                            </span>
                          </template>
                      </template>
                    </template>
                  </template>
                </b-row>
              </b-col>
              <b-col cols="2"></b-col>
          </b-row>
          <b-row v-if="d_showAplicationFooter" :style="f_calculateFooterBelowStyle()">
            <b-col sm="12" lg="2">
            </b-col>
            <b-col sm="12" lg="4">
              <p v-if="StoreFrontendSettings.data.navbar_middle_logo">
                <span >
                  <img :src="StoreFrontendSettings.data.navbar_middle_logo" style="height: 50px;" />
                </span>
              </p>
              <p>
                <span style="font-size: 16px;">© Copyright {{ StoreFrontendSettings.data.footer_date ? StoreFrontendSettings.data.footer_date : '' }}. All Rights Reserved.</span>
              </p>
            </b-col>
            <b-col sm="12" lg="4" style="text-align: center;">
              <div style="padding: 10px; font-size: 14px;">
                <strong style="padding: 3px; font-size: 20px;">
                  {{ StoreLangTranslation.data['follow_us'][StoreLang] }}
                </strong>
                <a v-if="StoreFrontendSettings.data.facebook_link" :href="StoreFrontendSettings.data.facebook_link" target="_target" style="margin-right: 10px;"><i class="fa fa-facebook"> </i></a>
                <a v-if="StoreFrontendSettings.data.twitter_link" :href="StoreFrontendSettings.data.twitter_link" target="_target" style="margin-right: 10px;"><i class="fa fa-twitter"></i></a>
                <a v-if="StoreFrontendSettings.data.instagram_link" :href="StoreFrontendSettings.data.instagram_link" target="_target" style="margin-right: 10px;"><i class="fa fa-instagram"></i></a>
                <a v-if="StoreFrontendSettings.data.linkedin_link" :href="StoreFrontendSettings.data.linkedin_link" target="_target" style="margin-right: 10px;"><i class="fa fa-linkedin"></i></a>
              </div>
            </b-col>
            <b-col sm="12" lg="2"></b-col>
          </b-row>
        </main>
      </div>

      <template>
        <div class="chat-support-wrapper">
          <template v-if="(d_user && d_user.username) || (d_mail && d_mail.mail && d_mail.mail_approve_code)">
            <div v-if="d_isSupportOpen" :class="['chat-panel', { 'sidebar-open': d_isSidebarOpen }]">
              <b-button size="sm" variant="outline-primary" class="panel-toggle-left" @click="f_toggleSidebar()" :disabled="!d_selectedSupportId">
                <i :class="d_isSidebarOpen ? 'fa fa-chevron-left' : 'fa fa-list'"></i>
              </b-button>

              <div class="chat-sidebar-inside" role="complementary" :aria-hidden="!d_isSidebarOpen">
                <b-button v-if="!d_user && d_mail && d_mail.mail && d_mail.mail_approve_code" size="sm" variant="outline-danger" style="position: absolute; top: 12px; right: 12px; width: 40px; height: 40px; z-index: 2100; border-radius: 20%; padding: 6px 8px;" @click="f_clearMailInfo()">
                  <i class="fa fa-sign-out"></i>
                </b-button>
                <support-list
                  :p_selectedSupportId="d_selectedSupportId"
                  :p_callFrom="'default_container'"
                  :p_refreshSupportList="d_refreshSupportList"
                  @changeRefreshSupportList="f_changeRefreshSupportList"
                  style="margin: 60px 15px 15px 15px;"
                  :f_updateMailInfo="f_updateMailInfo"
                  :p_mail="d_mail"
                  :f_clearMailInfo="f_clearMailInfo"
                  :p_selectThisSupport="f_selectThisSupport"
                />
              </div>
                  <!-- @changeSupportId="d_selectedSupportId = $event" -->

              <div class="panel-content" v-if="d_selectedSupportId" @click="f_rightPanelClick()">
                <b-button v-if="d_newSupportMessage" style="background-color: #ff4d4f; color: white; position: absolute; top: 15px; right: 30px; border-radius: 15px 0px; border: 1px solid #ff4d4f;; padding: 4px 10px; cursor: default; z-index: 9999;">
                  {{ StoreLangTranslation.data['new_message'][StoreLang] }}
                </b-button>
                <template v-if="d_supportType">
                  <support-detail v-if="d_supportType == 'user'"
                    :p_userSupportClientID="d_selectedSupportId"
                    :p_callFrom="'default_container'"
                    :p_newMessage="d_newSupportMessage"
                    @changeNewMessage="d_newSupportMessage = $event"
                    @changeRefreshSupportList="f_changeRefreshSupportList"
                    :p_supportType="d_supportType"
                  />
                  <support-detail v-else-if="d_supportType == 'mail'"
                    :p_mailSupportClientID="d_selectedSupportId"
                    :p_callFrom="'default_container'"
                    :p_newMessage="d_newSupportMessage"
                    @changeNewMessage="d_newSupportMessage = $event"
                    @changeRefreshSupportList="f_changeRefreshSupportList"
                    :p_mail="d_mail"
                    :f_clearMailInfo="f_clearMailInfo"
                    :p_supportType="d_supportType"
                  />
                </template>
              </div>
            </div>

            <div :class="d_isSupportOpen ? 'open chat-toggle-button' : 'chat-toggle-button'"
                 @click="f_changeStatusSupportPanel">
              {{ StoreLangTranslation.data['support'][StoreLang] }}
            </div>
          </template>

          <template v-else>
            <div v-if="d_isSupportOpen" :class="['chat-panel', { 'sidebar-open': d_isSidebarOpen }]">
              <template v-if="d_mailVerify">
                <mail-verify :f_updateMailInfo="f_updateMailInfo" style="margin: 60px 15px 15px 15px;"></mail-verify>
                <b-button @click="d_mailVerify = false" style="position: absolute; left: 20px; bottom: 20px;" variant="secondary">
                  {{ StoreLangTranslation.data['back'][StoreLang] }}
                </b-button>
              </template>
              <template v-else>
                <div style="margin-top: 75px; text-align: center;">
                  <b-row style="margin: 3px; font-size: 20px;">
                    <b-col cols="12">
                      <p>{{ StoreLangTranslation.data['support_login_1'][StoreLang] }}</p>
                    </b-col>
                  </b-row>
                  <b-row style="margin: 3px;">
                    <b-col cols="12">
                      <p>{{ StoreLangTranslation.data['support_login_2'][StoreLang] }}</p>
                    </b-col>
                  </b-row>

                  <b-row style="margin: 3px;">
                    <b-col cols="2"></b-col>
                    <b-col cols="8">
                      <b-button @click="f_goToLogin()" style="width: 100%;" variant="primary">
                        {{ StoreLangTranslation.data['login'][StoreLang] }}
                      </b-button>
                    </b-col>
                    <b-col cols="2"></b-col>
                  </b-row>
                  <b-row style="margin: 3px;">
                    <b-col cols="3"></b-col>
                    <b-col cols="6">
                      <hr/>
                    </b-col>
                    <b-col cols="3"></b-col>
                    </b-row>
                  <b-row style="margin: 3px;">
                    <b-col cols="2"></b-col>
                    <b-col cols="8">
                      <b-button @click="d_mailVerify = true" style="width: 100%;" variant="secondary">
                        {{ StoreLangTranslation.data['proceed_with_email'][StoreLang] }}
                      </b-button>
                    </b-col>
                    <b-col cols="2"></b-col>
                  </b-row>
                </div>
              </template>
            </div>
            <div :class="d_isSupportOpen ? 'open chat-toggle-button' : 'chat-toggle-button'"
                 @click="f_changeStatusSupportPanel">
              {{ StoreLangTranslation.data['support'][StoreLang] }}
            </div>
          </template>
        </div>
      </template>




      <template>
        <div class="cookies-div">
          <cookie-consent></cookie-consent>
        </div>
      </template>




      <b-modal id="store-loading" v-model="d_showLoadingModal" no-close-on-esc no-close-on-backdrop centered hide-footer hide-header-close body-bg-variant="dark" style="border-radius: 30px!important; z-index: 9999; box-shadow: -1px -1px 1px;">
        <b-row v-if="StoreLoading.data.label" style="vertical-align: middle; text-align: center;">
          <b-col sm="12" lg="1">
            <img src="../../public/img/gif/right-left.gif" class="img-rounded img-responsive" style="width: 30px; height: 30px;" />
          </b-col>
          <b-col sm="12" lg="11">
            <div style="padding-top: 5px;">{{ StoreLoading.data.label }}</div>
            <template v-if="d_progressData">
              <b-progress :value="d_progressData.percent" variant="success" show-progress striped :animated="true" class="mb-2"></b-progress>
              <div style="padding-top: 5px;">
                <span v-if="d_progressData.total_process_count"> Toplam İşlem: {{ d_progressData.total_process_count }} </span>
                <span v-if="d_progressData.process_count">İşlem Adedi: {{ d_progressData.process_count }} </span>
              </div>
              <div v-if="d_progressData.message" style="padding-top: 5px;"> Mesaj: {{ d_progressData.message }} </div>
            </template>
          </b-col>
        </b-row>
      </b-modal>
      <b-modal id="store-modal" v-model="d_showStoreModal" :title="StoreModal.data.title ? StoreModal.data.title : 'Uyarı'" :centered="StoreModal.data.centered ? StoreModal.data.centered : true" :header-bg-variant="StoreModal.data.header_bg_variant ? StoreModal.data.header_bg_variant : 'info'" :header-text-variant="StoreModal.data.header_text_variant ? StoreModal.data.header_text_variant : 'dark'">
        <div style="white-space: pre-line;" v-if="StoreModal.data.text">{{ StoreModal.data.text }}</div>
        <template slot="modal-footer">
          <b-button v-if="StoreModal.data.type === 'alert'" @click="d_showStoreModal = false">ok</b-button>
          <b-button v-if="StoreModal.data.type === 'confirm'" @click="d_showStoreModal = false">cancel</b-button>
          <b-button v-if="StoreModal.data.type === 'confirm'" @click="f_confirmStoreModal()">İşlemi gerçekleştir</b-button>
        </template>
      </b-modal>

    </div>
    <b-modal id="store-warning-code-modal" v-model="d_showWarningCodeModal" no-close-on-esc no-close-on-backdrop centered hide-footer hide-header-close style="border-radius: 30px!important; z-index: 9999; box-shadow: -1px -1px 1px;">
      <b-row>
        <b-col cols="12">
          <div v-if="d_warningCodeDb">
            {{ StoreLangTranslation.data['enter_warning_code'][StoreLang] }}
          </div>
          <div v-else>
            {{ StoreLangTranslation.data['enter_warning_code_from_mail'][StoreLang] }}
          </div>
        </b-col>
      </b-row>
      <b-row v-id="d_warningCodeDb">
        <b-col cols="12">
          <div id="captcha"></div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group validated label-for="normalCaptcha">
            <b-form-input id="captchaCode" type="text" :placeholder="StoreLangTranslation.data['write_captcha_code'][StoreLang]" required v-model="d_warningWrittenCode"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-button variant="primary" size="sm" style="padding: 10px;" :disabled="d_warningWrittenCode ? false : true">
            <span @click="f_enterWarningCode()">{{ StoreLangTranslation.data['send'][StoreLang] }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <!-- <b-modal v-if="d_ipWdm && d_showBlockModal" id="store-block-modal" no-close-on-esc no-close-on-backdrop centered hide-footer hide-header-close style="border-radius: 30px!important; z-index: 9999; box-shadow: -1px -1px 1px;"> -->
    <b-modal v-model="d_showBlockModal" id="store-block-modal" no-close-on-esc no-close-on-backdrop centered hide-footer hide-header-close style="border-radius: 30px!important; z-index: 9999; box-shadow: -1px -1px 1px;">
      <b-row>
        <b-col cols="12">
          <h3>
            {{ StoreLangTranslation.data['you_are_blocked'][StoreLang] }}
          </h3>
        </b-col>
      </b-row >
      <!-- <b-row v-if="d_block_type">
        <b-col cols="12">
          {{ d_ipWdm['0']['parameters']['13']['options'][d_block_type]['translation'][StoreLang] }}
        </b-col>
      </b-row>
      <b-row v-if="d_block_reason">
        <b-col cols="12">
          {{ d_ipWdm['0']['parameters']['14']['options'][d_block_reason]['translation'][StoreLang] }}
        </b-col>
      </b-row>
      <b-row v-if="d_block_reason_note">
        <b-col cols="12">
          {{ d_block_reason_note }}
        </b-col>
      </b-row> -->
    </b-modal>

    <b-modal v-model="d_searchModal" id="search-modal" :title="StoreLangTranslation.data['search'][StoreLang]" hide-footer size="xl" dialog-class="search-modal-dialog">
      <search></search>
    </b-modal>

    <b-toast id="info-toast" variant="info" solid no-auto-hide toaster="b-toaster-top-right" class="p-2" :title="StoreLangTranslation.data['information'][StoreLang]">
      <div class="toast-body-custom">

        <!-- <div class="d-flex align-items-center mb-2">
          <i class="fa fa-info-circle" style="margin-right: 5px"></i>
          <strong>{{ StoreLangTranslation.data['information'][StoreLang] }}</strong>
        </div> -->

        <div class="mb-3">
          <span>{{ StoreLangTranslation.data['count_of_active_products'][StoreLang] }}: </span>
          <!-- <b-badge variant="primary" class="ml-1"> -->
          <strong>
            {{ d_activeBundleCount }}
          </strong>
          <!-- </b-badge> -->
        </div>

        <b-row class="mb-3">
          <b-col cols="12" class="mb-2">
            <b-button size="sm" variant="outline-primary" block @click="f_goToActiveProducts()">
              {{ StoreLangTranslation.data['go_to_my_active_products_page'][StoreLang] }}
            </b-button>
          </b-col>

          <b-col cols="12">
            <b-button size="sm" variant="outline-secondary" block @click="f_goToProjects()">
              {{ StoreLangTranslation.data['go_to_projects_page'][StoreLang] }}
            </b-button>
          </b-col>
        </b-row>

        <div class="d-flex justify-content-between align-items-center">
          <b-form-checkbox v-model="d_dontShowAgain" @change="f_onCheckboxChange()">
            {{ StoreLangTranslation.data['do_not_show_again'][StoreLang] }}
          </b-form-checkbox>

          <b-button size="sm" variant="link" class="text-muted" @click="$bvToast.hide('info-toast')">
            {{ StoreLangTranslation.data['close'][StoreLang] }}
          </b-button>
        </div>

      </div>
    </b-toast>
  </div>
</template>

<script>
import { ClsWdm } from '@/wam/modules/wdm';
import { ClsRoute } from '@/wam/modules/route';
import { data as lang_list } from '@/wam/options/lang_list';
import auth from '@/auth';
import moment from "moment";
import { mapGetters } from 'vuex';
import { ServiceFunctions } from '@/wam/modules/service';
import { ClsUser } from '@/wam/modules/user';
import {
  default as SupportDetail
} from '@/wam/components/widgets/SupportDetail';
import {
  default as SupportList
} from '@/wam/components/widgets/SupportList';
import {
  default as MailVerify
} from '@/wam/components/widgets/MailVerify';
import {
  default as CookieConsent
} from '@/wam/components/widgets/CookieConsent';

import {
  default as Modal
} from '@/components/widgets/Modal';
import {
  default as Search
} from '@/wam/components/widgets/Search';
// import {default as WisdomSocket } from '@/components/socket';

export default {
  name: 'DefaultContainer',
  components: {
    Modal,
    SupportDetail,
    SupportList,
    MailVerify,
    // WisdomSocket
    CookieConsent,
    Search
  },
  computed: {
    ...mapGetters({
      StoreDevice: 'StoreDevice',
      StoreUser: 'StoreUser',
      StoreLoading: 'StoreLoading',
      StoreModal: 'StoreModal',
      StoreLang: 'StoreLang',
      StoreCurrencyType: 'StoreCurrencyType',
      StoreCurrencyTypeList: 'StoreCurrencyTypeList',
      StoreFrontendSettings: 'StoreFrontendSettings',
      StoreFrontendWebsiteunit: 'StoreFrontendWebsiteunit',
      // StoreMenuData: 'StoreMenuData',
      StoreLangList: 'StoreLangList',
      StoreLangTranslation: 'StoreLangTranslation',
      StoreShopCartList: 'StoreShopCartList',
      StoreShopCartOrderList: 'StoreShopCartOrderList',
      StoreWebsiteEdit: 'StoreWebsiteEdit',
      StoreWarningCodeModal: 'StoreWarningCodeModal',
      StoreLogout: 'StoreLogout',
    }),
    StoreMenuData () {
      const originalMenu = this.$store.getters.StoreMenuData;
      if (!originalMenu || !originalMenu.data || !Array.isArray(originalMenu.data.list)) {
        return originalMenu;
      }
      const clonedMenu = structuredClone(originalMenu);
      for (let clonedItem of clonedMenu.data.list) {
        if (
          clonedItem.component_name === 'shop' && this.StoreFrontendSettings && this.StoreFrontendSettings.data && this.StoreFrontendSettings.data.shop_text) {
          clonedItem.caption.en = this.StoreFrontendSettings.data.shop_text.en;
          clonedItem.caption.tr = this.StoreFrontendSettings.data.shop_text.tr;
        }
      }
      return clonedMenu;
    }
  },
  data () {
    return {
      d_frdWdm: '',
      d_websiteEditStatus: false,
      d_selectedParentMenuItemIndex: '',
      d_flowingTextInterval: 0,
      d_allFlowingText: {
        'list': [],
        'list_index': 0,
        'text': '',
        'index': 0,
        'wait': 0
      },
      d_topShowMenuIndexList: [],
      d_selectedLang: 'en',
      d_selectedCurrencyType: {'value': '0', 'label': '₺'},
      d_notShowBarRoutes: [],
      d_progressData: '',
      d_showAplicationFooter: true,
      d_showAplicationHeader: true,
      d_showAplicationSidebar: false,
      d_showLoadingModal: false,
      d_showStoreModal: false,
      d_user: '',
      d_mail: '',
      ClsUser: ClsUser,
      d_userSuppportList: [],
      d_selectedSupportId: '',
      d_newSupportMessage: false,
      d_isSupportOpen: false,
      d_isSidebarOpen: false,
      d_refreshSupportList: false,
      d_mailVerify: false,
      d_showWarningCodeModal: false,
      d_warningWrittenCode: '',
      d_warningCode: '',
      d_warningCodeDb: '',
      d_blockData: {},
      d_showBlockModal: false,
      d_block_date: '',
      d_block_type: '',
      d_block_reason: '',
      d_block_reason_note: '',
      d_ipWdm: '',
      d_supportType: '',
      d_dontShowAgain: false,
      d_activeBundleCount: 0,
      d_searchModal: false,
      d_searchText: '',
      d_searchLoading: false,
      d_searchResults: [],
      d_searchFrom: {
        'profile': '1',
        'bundle': '1',
        'webunit': '1'
      },
      d_userShopBundleWdm: '',
      d_paramMatch: {
        'bundle': {
          '1': {'tr': 'ad', 'en': 'name'},
          '38': {'tr': 'çeşitli değişkenler', 'en': 'various variables'},
          '39': {'tr': 'Dataset hakkında', 'en': 'About dataset'},
          '48': {'tr': 'dergi adı', 'en': 'journal name'},
          '49': {'tr': 'makale başlığı', 'en': 'article title'},
          '50': {'tr': 'Makale linki', 'en': 'Article link'},
          '58': {'tr': 'yazarın adı', 'en': 'author firstname'},
          '59': {'tr': 'yazarın soyadı', 'en': 'author lastname'},
          '67': {'tr': 'makale yazarının adı', 'en': 'article author firstname'},
          '68': {'tr': 'makale yazarının soyadı', 'en': 'article author lastname'},
        },
        'dataset': {
          '1': {'tr': 'ad', 'en': 'name'},
          '38': {'tr': 'çeşitli değişkenler', 'en': 'various variables'},
          '39': {'tr': 'Dataset hakkında', 'en': 'About dataset'},
          '48': {'tr': 'dergi adı', 'en': 'journal name'},
          '49': {'tr': 'makale başlığı', 'en': 'article title'},
          '50': {'tr': 'Makale linki', 'en': 'Article link'},
          '58': {'tr': 'yazarın adı', 'en': 'author firstname'},
          '59': {'tr': 'yazarın soyadı', 'en': 'author lastname'},
          '67': {'tr': 'makale yazarının adı', 'en': 'article author firstname'},
          '68': {'tr': 'makale yazarının soyadı', 'en': 'article author lastname'},
        },
        'webunit': {
          '2': {'tr': 'menü açıklaması', 'en': 'menu caption'},
          '8': {'tr': 'sayfa bilgisi açıklaması', 'en': 'page info caption'},
          '10': {'tr': 'sayfa bilgisi detay açıklaması', 'en': 'page info detail caption'},
          '26': {'tr': 'sayfa bilgisi detay notu', 'en': 'page info detail note'},
        }
      },
      d_refreshIntervalSec: 120,
      d_intervalId: null,
    }
  },
  destroyed () {
    clearInterval(this.d_flowingTextInterval);
    // clearInterval(this.d_nextDrawAlgorithm);
  },
  created: function () {
    // ClsWdm.getLayerWdm('ip').then(resp_wdm_data => { this.d_ipWdm = resp_wdm_data; });
    ClsWdm.getLayerWdm('usr_shp_bund').then(resp_wdm_data => { this.d_userShopBundleWdm = resp_wdm_data; });
    ClsWdm.getLayerWdm('frd').then(resp_wdm_data => { this.d_frdWdm = resp_wdm_data; });

    if (localStorage.getItem('WebsiteEdit') === 'yes') {
      this.d_websiteEditStatus = true;
    }
    // console.log('StoreWebsiteEdit : ', this.StoreWebsiteEdit);
    if (this.StoreMenuData.data.list) {
      for (let i in this.StoreMenuData.data.list) {
        if (this.StoreMenuData.data.list[i].show_in_menu.value === '1') {
          if (this.d_topShowMenuIndexList.length < 7) {
            this.d_topShowMenuIndexList.push(parseInt(i));
          }
        }
      }
    }
    // console.log('this.$route.meta', this.$route.meta);
    if (localStorage.getItem('lang')){
      this.d_selectedLang = localStorage.getItem('lang');
    }
    if (localStorage.getItem('user_currency_type')){
      this.d_selectedCurrencyType = JSON.parse(localStorage.getItem('user_currency_type'));
    }
    // console.log(this.StoreLangTranslation);
    // console.log(this.StoreLangList);
    // console.log(this.StoreMenuData);
    // console.log(this.StoreFrontendWebsiteunit);
    // console.log(this.StoreFrontendSettings);
    // console.log(this.StoreUser);
    // console.log('StoreDevice.isMobile : ', StoreDevice.isMobile);
    this.d_user = JSON.parse(localStorage.getItem('user'));
    this.d_mail = JSON.parse(localStorage.getItem('mail'));
    if (this.$route.meta.iframe_mode === 'yes') {
      // console.log(this.$route.meta.iframe_mode);
      this.d_showAplicationSidebar = false;
      this.d_showAplicationHeader = false;
      this.d_showAplicationFooter = false;
    } else {
      if (this.StoreDevice && this.StoreDevice.isMobile) {
        this.d_showAplicationSidebar = false;
      } else {
        if (this.StoreFrontendSettings.data.menu_type === '0') {
          this.d_showAplicationSidebar = false;
        } else if (this.StoreFrontendSettings.data.menu_type === '1') {
          this.d_showAplicationSidebar = false;
        } else if (this.StoreFrontendSettings.data.menu_type === '2') {
          this.d_showAplicationSidebar = true;
        }
        if (this.StoreFrontendSettings.data.navbar_flowing_text && this.StoreFrontendSettings.data.navbar_flowing_text[this.d_selectedLang]) {
          this.d_allFlowingText.list.push({'label': this.StoreFrontendSettings.data.navbar_flowing_text[this.d_selectedLang]});
          this.f_startFlowingText();
        }
      }
    }
    if (this.d_user && this.d_user.username) {
      this.f_userShopCartBundleList();
      this.f_userShopCartBundleOrderList();
    }
    this.f_enableGoogleAnalytics();
    this.f_enableGoogleRecaptcha();
  },
  destroyed () {},
  beforeCreate: function () {
  },
  mounted: function () {
    if (this.StoreLoading.status) {
      this.d_showLoadingModal = true;
    }
    this.d_isSidebarOpen = true;
    if (this.d_user && this.d_user.username) {
      let saved = localStorage.getItem("dontShowAgainToast");
      if (saved !== "true") {
        this.f_userShopCartBundleActiveList();
      }
    }
    this.d_sessionEndDate = Date.now() + 45 * 60 * 1000;
    this.d_intervalId = setInterval(() => {
      this.f_checkSession();
    }, this.d_refreshIntervalSec * 1000);

  },
  beforeDestroy() {
    if (this.d_intervalId) {
      clearInterval(this.d_intervalId);
      this.d_intervalId = null;
    }
  },
  methods: {
    f_updateSession: function () {
      this.d_sessionEndDate = Date.now() + 45 * 60 * 1000;
    },
    f_checkSession: function () {
      if (Date.now() >= this.d_sessionEndDate) {
        if (this.d_user && this.d_user.username) {
          this.f_logout();
        }
      }
    },
    f_openSearchModal: function () {
      // const storage_last_srch = JSON.parse(localStorage.getItem("last_search"));
      // try {
      //   this.d_searchText = storage_last_srch.search_text;
      // } catch {}
      // try {
      //   this.d_searchResults = storage_last_srch.search_results;
      // } catch {}
      // try {
      //   this.d_searchFrom = storage_last_srch.search_from;
      // } catch {}
      this.d_searchModal = true;
    },
    f_goToProjects: function (user_shop_client_id) {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_project', this.StoreLang)});
      this.f_hideToast();
    },
    f_goToActiveProducts: function (user_shop_client_id) {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_product_bundles_active', this.StoreLang)});
      this.f_hideToast();
    },
    f_hideToast() {
      this.$bvToast.hide("info-toast")
    },
    f_onCheckboxChange() {
      localStorage.setItem("dontShowAgainToast", this.d_dontShowAgain ? "true" : "false");
    },
    f_userShopCartBundleActiveList: function () {
      let query = 'user_client_id=' + this.d_user.username;
      let data = {};
      ServiceFunctions.user_shopcart_bundle_active_list(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            let shop_order_list = resp.data.list;
            let total = 0;
            for (let shop of shop_order_list) {
              total += shop.bundle_list.length;
            }

            if (total > 0) {
              this.d_activeBundleCount = total;
              this.$bvToast.show("info-toast")
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_enterWarningCode: function () {
      if (this.d_warningWrittenCode) {
        let go_check = true;
        if (this.d_warningCodeDb) {
          if (this.d_warningWrittenCode != this.d_warningCode) {
            go_check = false;
          }
        }
        if (go_check) {
          let query = 'warning_code=' + this.d_warningWrittenCode;
          let data = {};
          ServiceFunctions.warning_code_enter(query, data)
            .then(resp => {
              if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
                if (resp.data.warning_approve && resp.data.warning_approve == '1') {
                  // kod doğru
                  alert('güvenlik kodu doğru');
                  window.location.reload();
                } else {
                  alert('güvenlik kodu yanlış');
                }
              } else {
                alert(resp.data.status_code + ' = ' + resp.data.status_message);
              }
            });
        } else {
          alert('güvenlik kodu yanlış');
          // this.f_createCaptcha();
          this.d_warningWrittenCode = ''
        }
      } else {
        alert("güvenlik kodu boş olamaz")
      }
    },
    f_createCaptcha: function() {
      if (this.d_warningCodeDb) {
        // console.log("f_createCaptcha")
        this.d_warningWrittenCode = '';
        // this.d_warningCode = '';
        //clear the contents of captcha div first 
        document.getElementById('captcha').innerHTML = "";
        // let charsArray = "0123456789";
        // let lengthOtp = 4;
        // let captcha = [];
        // for (let i = 0; i < lengthOtp; i++) {
        //   //below code will not allow Repetition of Characters
        //   let index = Math.floor(Math.random() * charsArray.length); //get the next character from the array
        //   if (captcha.indexOf(charsArray[index]) == -1)
        //     captcha.push(charsArray[index]);
        //   else i--;
        // }
        // console.log(this.d_warningCodeDb)
        let captcha = Math.sqrt(this.d_warningCodeDb).toString();

        let canv = document.createElement("canvas");
        canv.id = "captcha";
        canv.width = 100;
        canv.height = 50;
        let ctx = canv.getContext("2d");
        ctx.font = "25px Georgia";
        ctx.strokeText(captcha, 0, 30);
        //storing captcha so that can validate you can save it somewhere else according to your specific requirements
        this.d_warningCode = captcha;
        // console.log('this.d_warningCode : ', this.d_warningCode);
        document.getElementById("captcha").appendChild(canv); // adds the canvas to the body element
        this.$forceUpdate();
      }
    },
    f_goToLogin: function () {
      this.d_mailVerify = false;
      this.d_isSupportOpen = false;
      this.$router.push({ path: '/login', query: {} });
    },
    f_rightPanelClick: function () {
      this.d_newSupportMessage = false
      this.d_isSidebarOpen = false;
    },
    f_clearMailInfo: function () {
      localStorage.removeItem('mail');
      this.d_mail = '';
    },
    f_updateMailInfo: function (mail, mail_approve_code) {
      localStorage.setItem('mail', JSON.stringify({'mail': mail, 'mail_approve_code': mail_approve_code}));
      this.d_mail = {
        'mail': mail,
        'mail_approve_code': mail_approve_code,
      }
    },
    f_closeSupport: function () {
      this.d_isSupportOpen = false;
      this.d_isSidebarOpen = true;
      this.d_mailVerify = false;
    },

    f_toggleSidebar() {
      this.d_isSidebarOpen = !this.d_isSidebarOpen;
    },
    f_selectThisSupport(id, support_type) {
      this.d_supportType = '';
      this.d_isSidebarOpen = false;
      setTimeout(function () {
        this.d_selectedSupportId = id;
        this.d_supportType = support_type;
      }.bind(this), 200);
    },
    f_changeRefreshSupportList(new_val) {
      this.d_refreshSupportList = new_val; 
    },
    f_userSupportList: function () {
      this.d_userSuppportList = [];
      let query = 'user_client_id=' + this.d_user.username;
      let data = {};
      ServiceFunctions.user_support_list(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list) {
              this.d_userSuppportList = resp.data.list;
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_changeStatusSupportPanel: function () {
      if (!this.d_isSupportOpen) {
        this.d_mail = JSON.parse(localStorage.getItem('mail'));
      }
      this.d_mailVerify = false;
      this.d_isSupportOpen = !this.d_isSupportOpen;
      this.d_isSidebarOpen = true;
      this.d_selectedSupportId = '';
    },
    f_showLanguageName: function (lang_code) {
      let lang_label = '';
      if (this.StoreFrontendSettings.data.language_change_button_type) {
        // 0 büyük harflerle kod code in uppercase letters
        // 1 küçük harflerle kod code in lowercase letters
        // 2 yalnızca bayrak ikonları  flag icons only
        // 3 bayrak ikonu ve kod flag icon and code
        if (this.StoreFrontendSettings.data.language_change_button_type === '0') {
          lang_label = lang_code;
          lang_label = lang_label.toLocaleUpperCase();
        } else if (this.StoreFrontendSettings.data.language_change_button_type === '1') {
          lang_label = lang_code;
          lang_label = lang_label.toLocaleLowerCase();
        } else if (this.StoreFrontendSettings.data.language_change_button_type === '2') {
          lang_label = lang_code;
          lang_label = lang_label.toLocaleUpperCase();
        } else if (this.StoreFrontendSettings.data.language_change_button_type === '3') {
          lang_label = lang_code;
          lang_label = lang_label.toLocaleUpperCase();
        } else {
          // normalde burası yok. Güvenlik amaçlı eklendi.
          lang_label = lang_code;
        }
      } else {
        lang_label = lang_code;
      }
      return lang_label;
    },
    f_loginButtonName: function () {
      let login_button_name = '';
      if (this.StoreFrontendSettings.data.login_button_name && this.StoreFrontendSettings.data.login_button_name[this.StoreLang]) {
        login_button_name = this.StoreFrontendSettings.data.login_button_name[this.StoreLang];
      } else {
        login_button_name = this.StoreLangTranslation.data['login'][this.StoreLang];
      }
      return login_button_name;
    },
   f_enableGoogleRecaptcha: function () {
    // this.StoreFrontendSettings.data.google_recaptcha_key = '';
    let google_recaptcha_key = '';
    try {
      google_recaptcha_key = this.StoreFrontendSettings.data.google_recaptcha_key;
    } catch(err) {}
    if (google_recaptcha_key) {
      var script_element = document.createElement('script');
      var f = document.getElementsByTagName('script')[0];
      script_element.async = true;
      script_element.src = 'https://www.google.com/recaptcha/enterprise.js?render=' + google_recaptcha_key;
      f.parentNode.insertBefore(script_element, f);
    }
   },
   f_enableGoogleAnalytics: function () {
    // async f_enableGoogleAnalytics() {
    let googleAnalyticsId = this.StoreFrontendSettings.data.google_analytics_id;
    if (googleAnalyticsId) {
       // let googleAnalyticsId = 'G-BG7F12P16C';
       this.f_activateGtm(window, document, 'script', 'dataLayer', googleAnalyticsId);
    }
   },
   f_activateGtm: function (w, doc, scrpt, dataLayer, googleAnalyticsId) {
       w[dataLayer] = w[dataLayer] || [];
       w[dataLayer].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
       var f = doc.getElementsByTagName(scrpt)[0];
       var script_element = doc.createElement(scrpt);
       var dl = dataLayer != 'dataLayer' ? '&l=' + dataLayer : '';
       script_element.async = true;
       script_element.src = 'https://www.googletagmanager.com/gtm.js?id=' + googleAnalyticsId + dl;
       // console.log('script_element.src : ', script_element.src);
       f.parentNode.insertBefore(script_element, f);

      window.dataLayer = window.dataLayer || [];
      function gtag() {
          window.dataLayer.push(arguments);
      }
      gtag('js', new Date());
      gtag('config', googleAnalyticsId);
   },
    f_shopVisibilityCheck: function () {
      let show_eligible = false;
      if (this.StoreFrontendSettings && this.StoreFrontendSettings.data && this.StoreFrontendSettings.data.are_shop_pages_active === '1') {
        if (this.StoreFrontendSettings && this.StoreFrontendSettings.data && this.StoreFrontendSettings.data.market_visiblity_type === '0') {
          show_eligible = true;
        } else if (this.StoreFrontendSettings && this.StoreFrontendSettings.data && this.StoreFrontendSettings.data.market_visiblity_type === '1') {
          if (this.d_user && this.d_user.username) {
            show_eligible = true;
          } else {
            show_eligible = false;
          }
        }
      } else {
        show_eligible = false;
      }
      return show_eligible;
    },
    f_checkMenuShowEligibleFound: function (menu_item) {
      let show_eligible = true;
      if (!menu_item.list) {
        show_eligible = false;
      } else {
        let det = false;
        for (let sub_menu_item_index in menu_item.list) {
          let sub_menu_item = menu_item.list[sub_menu_item_index];
          if (this.f_checkMenuPermission(sub_menu_item)) {
            if (sub_menu_item.show_in_menu && sub_menu_item.show_in_menu.value === '1') {
              if (sub_menu_item.route_path) {
                det = true;
                break;
              }
            }
          }
        }
        if (!det) {
          show_eligible = false;
        }
      }
      return show_eligible;
    },
    f_menuMouseOver: function (over_type, menu_item_index, sub_menu_item_index='') {
      // console.log('f_menuMouseOver ', menu_item_index);
      // console.log(this.$refs['menu_item__' + menu_item_index]);
      if (over_type === 'dropdown') {
        this.$refs['menu_item__' + menu_item_index][0].show();
      }
      if (sub_menu_item_index !== '') {
        this.d_selectedParentMenuItemIndex = menu_item_index.toString() + '.' + sub_menu_item_index.toString();
      } else {
        this.d_selectedParentMenuItemIndex = menu_item_index;
      }
      // console.log(this.$refs['menu_item__' + menu_item_index][0]);
      // this.$refs['menu_item' + menu_item_index].showMenu = true;
    },
    f_menuMouseLeave: function () {
      // console.log('f_menuMouseLeave ', menu_item_index);
      // this.$refs['menu_item__' + menu_item_index][0].show();
      this.d_selectedParentMenuItemIndex = '';
      // console.log(this.$refs['menu_item__' + menu_item_index][0]);
      // this.$refs['menu_item' + menu_item_index].showMenu = true;
    },
    f_selectLang: function (lang) {
      this.d_selectedLang = lang.label;
      localStorage.setItem('lang', this.d_selectedLang);
      localStorage.setItem('active_lang', JSON.stringify(lang));
      if (this.StoreFrontendSettings.data.navbar_flowing_text && this.StoreFrontendSettings.data.navbar_flowing_text[this.d_selectedLang]) {
        this.d_allFlowingText.list = [];
        this.d_allFlowingText.list.push({'label': this.StoreFrontendSettings.data.navbar_flowing_text[this.d_selectedLang]});
        clearInterval(this.d_flowingTextInterval);
        this.f_startFlowingText();
      }
    },
    f_startFlowingText: function () {
      // when we start, we defined the list index we are flowing on.
      if (this.d_allFlowingText.list.length > 0) {
        this.d_allFlowingText.text = this.d_allFlowingText.list[0].label;
        this.d_allFlowingText.list_index = 0;
        this.d_flowingTextInterval = setInterval(function () {
          if (this.d_allFlowingText.index !== this.d_allFlowingText.text.length) {
            this.d_allFlowingText.index += 1;
          } else {
            // 30 defa wait olduktan sonra tüm text yeniden başa sarıyor.
            if (this.d_allFlowingText.wait === 30) {
              this.d_allFlowingText.wait = 0;
              this.d_allFlowingText.index = 0;
              if (this.d_allFlowingText.list_index !== this.d_allFlowingText.list.length - 1) {
                this.d_allFlowingText.list_index += 1;
                this.d_allFlowingText.text = this.d_allFlowingText.list[this.d_allFlowingText.list_index].label;
              } else {
                this.d_allFlowingText.list_index = 0;
                this.d_allFlowingText.text = this.d_allFlowingText.list[0].label;
              }
            } else {
              this.d_allFlowingText.wait += 1;
            }
          }
        }.bind(this), 100);
      }
    },
    f_calculateFooterBelowStyle: function () {
      let style = 'padding-top: 50px; padding-bottom: 100px;';

      let footer_background_color = 'whitesmoke';
      if (this.StoreFrontendSettings.data.footer_background_color) {
        footer_background_color = this.StoreFrontendSettings.data.footer_background_color;
      }
      style += 'background-color: ' + footer_background_color + ';';

      let footer_text_size = '14';
      if (this.StoreFrontendSettings.data.footer_text_size) {
        footer_text_size = this.StoreFrontendSettings.data.footer_text_size;
      }
      style += 'font-size: ' + footer_text_size + 'px;';

      let footer_text_weight = '400';
      if (this.StoreFrontendSettings.data.footer_text_weight) {
        footer_text_weight = this.StoreFrontendSettings.data.footer_text_weight;
      }
      style += 'font-weight: ' + footer_text_weight + 'px;';

      let footer_text_color = 'rgb(36, 80, 90)';
      if (this.StoreFrontendSettings.data.footer_text_color) {
        footer_text_color = this.StoreFrontendSettings.data.footer_text_color;
      }
      style += 'color: ' + footer_text_color + ';';
      return style;
    },
    f_calculateFooterStyle: function () {
      let style = 'margin-top: 100px;';
      let footer_background_color = 'whitesmoke';
      if (this.StoreFrontendSettings.data.footer_background_color) {
        footer_background_color = this.StoreFrontendSettings.data.footer_background_color;
      }
      style += 'background-color: ' + footer_background_color + ';';

      let footer_text_size = '16';
      if (this.StoreFrontendSettings.data.footer_text_size) {
        footer_text_size = this.StoreFrontendSettings.data.footer_text_size;
      }
      style += 'font-size: ' + footer_text_size + 'px;';

      let footer_text_weight = '300';
      if (this.StoreFrontendSettings.data.footer_text_weight) {
        footer_text_weight = this.StoreFrontendSettings.data.footer_text_weight;
      }
      style += 'font-weight: ' + footer_text_weight + 'px;';

      let footer_text_color = 'rgb(36, 80, 90)';
      if (this.StoreFrontendSettings.data.footer_text_color) {
        footer_text_color = this.StoreFrontendSettings.data.footer_text_color;
      }
      style += 'color: ' + footer_text_color + ';';
      return style;
    },
    f_calculateAppContainerStyle: function () {
      let style = 'font-weight: 400;';

      let font_family = 'Inter';
      if (this.StoreFrontendSettings.data.general_font_select) {
        font_family = this.f_getOptionLabel(this.StoreFrontendSettings.data.general_font_select, this.d_frdWdm['0']['parameters']['88']['options']);
      } else if (this.StoreFrontendSettings.data.general_font_style) {
        font_family = this.StoreFrontendSettings.data.general_font_style;
      }
      style += 'font-family: ' + font_family + ';';

      let page_area_text_color = 'rgb(36, 80, 90)';
      if (this.StoreFrontendSettings.data.page_area_text_color) {
        page_area_text_color = this.StoreFrontendSettings.data.page_area_text_color;
      }
      style += 'color: ' + page_area_text_color + ';';
      return style;
    },
    f_calculateMenuCaptionStyle: function (menu_type, menu_item_index='', sub_menu_item_index='', type='') {
      let footer_text_padding = '3';
      if (this.StoreFrontendSettings.data.footer_text_padding) {
        footer_text_padding = this.StoreFrontendSettings.data.footer_text_padding;
      }

      let footer_text_size = '16';
      if (this.StoreFrontendSettings.data.footer_text_size) {
        footer_text_size = this.StoreFrontendSettings.data.footer_text_size;
      }
      // console.log('footer_text_size : ', footer_text_size);
      let style = '';
      let text_color = 'rgb(36, 80, 90)';

      // console.log(this.StoreFrontendSettings.data.navbar_background_color);
      if (menu_type === 'parent') {
        if (type === 'footer') {
          style += 'padding: ' + footer_text_padding + 'px;';
          style += 'font-size: ' + footer_text_size + 'px;';
        } else {
          style += 'font-size: 20px;';
          style += 'font-weight: 500;';
        }
        if (this.StoreFrontendSettings.data.menu_parent_item_text_color) {
          text_color = this.StoreFrontendSettings.data.menu_parent_item_text_color;
        }
        if (this.d_selectedParentMenuItemIndex !== '' && menu_item_index === this.d_selectedParentMenuItemIndex) {
          style += 'border-bottom: solid 5px ' + text_color + ';';
          style += 'color: #3f87ff;';
        } else {
          style += 'color: ' + text_color + ';';
        }
      } else if (menu_type === 'child') {
        if (type === 'footer') {
          style += 'padding: ' + footer_text_padding + 'px;';
          style += 'font-size: ' + (parseInt(footer_text_size) - 3) + 'px;';
        } else {
          style += 'font-size: 18px;';
          style += 'font-weight: 300;';
        }
        // style += 'margin-left: 10px;';
        if (this.StoreFrontendSettings.data.menu_child_item_text_color) {
          text_color = this.StoreFrontendSettings.data.menu_child_item_text_color;
        }
        if (this.d_selectedParentMenuItemIndex !== '' && menu_item_index.toString() + '.' + sub_menu_item_index.toString() === this.d_selectedParentMenuItemIndex) {
          style += 'border-bottom: solid 5px ' + text_color + ';';
          style += 'color: #3f87ff;';
        } else {
          style += 'color: ' + text_color + ';';
        }
      }
      return style;
    },
    f_calculateTotalMainManuCount: function () {
      let total_main_menu_count = 1;
      let h = 115;
      for (let menu_item_index in this.StoreMenuData.data.list) {
        let menu_item = this.StoreMenuData.data.list[menu_item_index];
        let check_menu_item = this.f_checkMenuPermission(menu_item);
        // console.log('check_menu_item: ', check_menu_item);
        if (this.StoreMenuData.data.list[menu_item_index].show_in_menu.value === '1' && check_menu_item) {
          total_main_menu_count += 1;
        }
      }
      // her 4 adet ana menü için yükseklik düzenlemesi yapılıyor.
      if (total_main_menu_count <= 4) {
        h = 115;
      } else if (total_main_menu_count > 5 && total_main_menu_count <= 10) {
        h = 115 + 50;
      } else if (total_main_menu_count > 10 && total_main_menu_count <= 15) {
        h = 115 + 50 + 50;
      }
      return h;
    },
    f_navBarTopMenuStyle: function () {
      let style = '';
      // let box_shadow_color = '2px 1px 2px 1px #c5ded9;';
      let box_shadow_color = '2px 1px 2px 1px rgba(250, 250, 250, 1);';
      // console.log(this.StoreFrontendSettings.data.navbar_background_color);
      // if (this.StoreFrontendSettings.data.navbar_background_color) {
      //   box_shadow_color = '2px 1px 2px 1px ' + this.StoreFrontendSettings.data.navbar_background_color;
      // }
      // contact us ile birlikte menüyü saydığımızdan total_main_menu_count değerini 1 ile saymaya başlıyoruz.
      let h = this.f_calculateTotalMainManuCount();
      // console.log('total_main_menu_count: ', total_main_menu_count);
      style += 'height: ' + h + 'px;';
      style += 'box-shadow: ' + box_shadow_color + ';';
      style += 'background-color: white;';
      style += 'z-index: 1000;';
      style += 'position: fixed;';
      style += 'width: 100%;';
      return style;
    },
    f_calculateNavbarStyle: function () {
      navbar_text_weight
      let style = 'margin: 0px; height: 40px;';

      let navbar_font_size = '15';
      if (this.StoreFrontendSettings.data.navbar_font_size) {
        navbar_font_size = this.StoreFrontendSettings.data.navbar_font_size;
      }
      style += "font-size: " + navbar_font_size + "px;"

      let navbar_text_weight = '300';
      if (this.StoreFrontendSettings.data.navbar_text_weight) {
        navbar_text_weight = this.StoreFrontendSettings.data.navbar_text_weight;
      }
      style += "font-weight: " + navbar_text_weight + ";"

      let navbar_background_color = 'rgb(39 176 178)';
      if (this.StoreFrontendSettings.data.navbar_background_color) {
        navbar_background_color = this.StoreFrontendSettings.data.navbar_background_color;
      }
      style += "background-color: " + navbar_background_color + ";"

      let navbar_text_color = 'white';
      if (this.StoreFrontendSettings.data.navbar_text_color) {
        navbar_text_color = this.StoreFrontendSettings.data.navbar_text_color;
      }
      style += "color: " + navbar_text_color + ";"
      return style;
    },
    f_calculateShopcartButtonStyle: function (call_from='') {
      let style = '';

      let navbar_font_size = '15';
      if (this.StoreFrontendSettings.data.navbar_font_size) {
        navbar_font_size = this.StoreFrontendSettings.data.navbar_font_size;
      }
      style += "font-size: " + navbar_font_size + "px;"

      let navbar_text_weight = '300';
      if (this.StoreFrontendSettings.data.navbar_text_weight) {
        navbar_text_weight = this.StoreFrontendSettings.data.navbar_text_weight;
      }
      style += "font-weight: " + navbar_text_weight + ";"
      if (call_from == '') {
        let navbar_text_color = 'white';
        if (this.StoreFrontendSettings.data.navbar_text_color) {
          navbar_text_color = this.StoreFrontendSettings.data.navbar_text_color;
        }
        style += "color: " + navbar_text_color + ";"
      }
      return style;
    },
    f_calculateSelectedLangStyle: function () {
      let style = '';

      let navbar_font_size = '15';
      if (this.StoreFrontendSettings.data.navbar_font_size) {
        navbar_font_size = this.StoreFrontendSettings.data.navbar_font_size;
      }
      style += "font-size: " + navbar_font_size + "px;"

      let navbar_text_weight = '300';
      if (this.StoreFrontendSettings.data.navbar_text_weight) {
        navbar_text_weight = this.StoreFrontendSettings.data.navbar_text_weight;
      }
      style += "font-weight: " + navbar_text_weight + ";"

      let navbar_text_color = 'white';
      if (this.StoreFrontendSettings.data.navbar_text_color) {
        navbar_text_color = this.StoreFrontendSettings.data.navbar_text_color;
      }
      style += "color: " + navbar_text_color + ";"
      return style;
    },
    f_calculateSelectedCurrencyStyle: function () {
      let style = '';

      let navbar_font_size = '15';
      if (this.StoreFrontendSettings.data.navbar_font_size) {
        navbar_font_size = this.StoreFrontendSettings.data.navbar_font_size;
      }
      style += "font-size: " + navbar_font_size + "px;"

      let navbar_text_weight = '300';
      if (this.StoreFrontendSettings.data.navbar_text_weight) {
        navbar_text_weight = this.StoreFrontendSettings.data.navbar_text_weight;
      }
      style += "font-weight: " + navbar_text_weight + ";"

      let navbar_text_color = 'white';
      if (this.StoreFrontendSettings.data.navbar_text_color) {
        navbar_text_color = this.StoreFrontendSettings.data.navbar_text_color;
      }
      style += "color: " + navbar_text_color + ";"
      return style;
    },
    f_calculateUsernameShowStyle: function () {
      let style = 'padding: 3px;';

      let navbar_font_size = '15';
      if (this.StoreFrontendSettings.data.navbar_font_size) {
        navbar_font_size = this.StoreFrontendSettings.data.navbar_font_size;
      }
      style += "font-size: " + navbar_font_size + "px;"

      let navbar_text_weight = '300';
      if (this.StoreFrontendSettings.data.navbar_text_weight) {
        navbar_text_weight = this.StoreFrontendSettings.data.navbar_text_weight;
      }
      style += "font-weight: " + navbar_text_weight + ";"

      let navbar_text_color = 'white';
      if (this.StoreFrontendSettings.data.navbar_text_color) {
        navbar_text_color = this.StoreFrontendSettings.data.navbar_text_color;
      }
      style += "color: " + navbar_text_color + ";"
      return style;
    },
    f_calculateLoginButtonShowStyle: function () {
      let style = 'padding: 3px;';

      let navbar_font_size = '15';
      if (this.StoreFrontendSettings.data.navbar_font_size) {
        navbar_font_size = this.StoreFrontendSettings.data.navbar_font_size;
      }
      style += "font-size: " + navbar_font_size + "px;"

      let navbar_text_weight = '300';
      if (this.StoreFrontendSettings.data.navbar_text_weight) {
        navbar_text_weight = this.StoreFrontendSettings.data.navbar_text_weight;
      }
      style += "font-weight: " + navbar_text_weight + ";"

      let navbar_text_color = 'white';
      if (this.StoreFrontendSettings.data.navbar_text_color) {
        navbar_text_color = this.StoreFrontendSettings.data.navbar_text_color;
      }
      style += "color: " + navbar_text_color + ";"
      return style;
    },
    f_clickMainArea: function () {
      if (this.StoreFrontendSettings.data.menu_type === '0') {
        //
      } else if (this.StoreFrontendSettings.data.menu_type === '1') {
        this.d_showAplicationSidebar = false;
      } else if (this.StoreFrontendSettings.data.menu_type === '2') {
        //
      }
    },
    f_menuAreaClick: function () {
      // console.log('this.StoreDevice.isMobile ', this.StoreDevice.isMobile);
      if (this.StoreDevice.isMobile) {
        this.d_showAplicationSidebar = false;
      } else {
        if (this.StoreFrontendSettings.data.menu_type === '0') {
          //
        } else if (this.StoreFrontendSettings.data.menu_type === '1') {
          this.d_showAplicationSidebar = false;
        } else if (this.StoreFrontendSettings.data.menu_type === '2') {
          //
        }
      }
    },
    f_createThisRouteHrefLink: function (route_name) {
      let route_menu_item = '';
      for (let i in this.StoreMenuData.data.list) {
        if (this.StoreMenuData.data.list[i].route_name === route_name) {
          route_menu_item = this.StoreMenuData.data.list[i];
          break
        }
        if (this.StoreMenuData.data.list[i].list && this.StoreMenuData.data.list[i].list.length > 0) {
          for (let sub_i in this.StoreMenuData.data.list[i].list) {
            if (this.StoreMenuData.data.list[i].list[sub_i].route_name === route_name) {
              route_menu_item = this.StoreMenuData.data.list[i].list[sub_i];
              break
            }
          }
        }
        if (route_menu_item !== '') {
          break
        }
      }
      // console.log('route_menu_item :', route_menu_item);
      let href_link = this.f_createHrefLink(route_menu_item);
      // console.log('href_link : ', href_link);
      return href_link;
    },
    f_createHrefLink: function (menu_item) {
      let route_path = '';
      let href_url = '';
      try {
        route_path = menu_item.route_path[this.StoreLang];
      } catch (err) {}
      // console.log('route_path : ', route_path);
      if (route_path) {
        if (route_path[0] === '/') {
          // href_url = window.location.origin + '/#' + route_path;
          href_url = window.location.origin + route_path;
        } else {
          // href_url = window.location.origin + '/#/' + route_path;
          href_url = window.location.origin + '/' + route_path;
        }
      } else {
        href_url = window.location.origin;
      }
      return href_url;
    },
    f_goToRoute: function (menu_item='', route_name='') {
      let route_path = '';
      if (route_name) {
        let route_menu_item = '';
        for (let i in this.StoreMenuData.data.list) {
          if (this.StoreMenuData.data.list[i].route_name === route_name) {
            route_menu_item = this.StoreMenuData.data.list[i];
            break
          }
          if (this.StoreMenuData.data.list[i].list && this.StoreMenuData.data.list[i].list.length > 0) {
            for (let sub_i in this.StoreMenuData.data.list[i].list) {
              if (this.StoreMenuData.data.list[i].list[sub_i].route_name === route_name) {
                route_menu_item = this.StoreMenuData.data.list[i].list[sub_i];
                break
              }
            }
          }
          if (route_menu_item !== '') {
            break
          }
        }
        if (route_menu_item) {
          try {
            route_path = route_menu_item.route_path[this.StoreLang];
          } catch (err) {}
        }
      } else {
        try {
          route_path = menu_item.route_path[this.StoreLang];
        } catch (err) {}
      }
      // console.log('this.$router : ', this.$router);
      // console.log('route_path : ', route_path);
      if (route_path) {
        // this.$router.push({ path: '/', query: {} });
        // this.$router.push({ path: route_path, query: {} });
        if (route_path[0] !== '/') {
          route_path = '/' + route_path;
        }
        this.$router.push({ path: route_path, query: {} });
      }
    },
    f_selectCurrencyType: function (cur_type) {
      this.d_selectedCurrencyType.value = cur_type.value;
      this.d_selectedCurrencyType.label = cur_type.label;
      localStorage.setItem('user_currency_type', JSON.stringify(cur_type));
    },
    f_getRedirectDashboardRoute: function () {
      let redirect_dashboard_path = '';
      for (let lang_index in lang_list) {
        let lang_label = lang_list[lang_index]['label'];
        for (let i in this.StoreMenuData.data.list) {
          let is_dashboard = '';
          try {
            is_dashboard = this.StoreMenuData.data.list[i].is_dashboard['value'];
          } catch (err) {}
          if (is_dashboard === '1') {
            let route_path = '';
            try {
              route_path = this.StoreMenuData.data.list[i].route_path[lang_label];
            } catch (err) {}
            if (route_path) {
              redirect_dashboard_path = route_path;
              break;
            }
          }
          if (this.StoreMenuData.data.list[i].list && this.StoreMenuData.data.list[i].list.length > 0) {
            for (let sub_i in this.StoreMenuData.data.list[i].list) {
              let is_dashboard = '';
              try {
                is_dashboard = this.StoreMenuData.data.list[i].list[sub_i].is_dashboard['value'];
              } catch (err) {}
              if (is_dashboard === '1') {
                let route_path = '';
                try {
                  route_path = this.StoreMenuData.data.list[i].list[sub_i].route_path[lang_label];
                } catch (err) {}
                if (route_path) {
                  redirect_dashboard_path = route_path;
                  break;
                }
              }

            }
          }
        }
      }
      // console.log('this.StoreMenuData ', this.StoreMenuData);
      // console.log('redirect_dashboard_path : ', redirect_dashboard_path);
      return redirect_dashboard_path;
    },
    f_checkLoginMenuItem: function (menu_item) {
      // are_shop_pages_active
      // tüm izinlerin destekleyeceği şekilde kontrol yapılıyor. Yani and mantığında.
      // console.log(menu_item.meta.login);
      let login_menu_item = true;
      if (menu_item.meta && menu_item.meta.login === 'yes') {
        if (this.d_user && this.d_user.username) {
          //
        } else {
          login_menu_item = false;
        }
      }
      return login_menu_item;
    },
    f_checkMenuPermission: function (menu_item) {
      // console.log('this.StoreFrontendSettings.data.market_visiblity_type : ', this.StoreFrontendSettings.data.market_visiblity_type);
      // are_shop_pages_active
      // tüm izinlerin destekleyeceği şekilde kontrol yapılıyor. Yani and mantığında.
      // console.log(menu_item.meta.login);
      // console.log('menu_item.route_name : ', menu_item.route_name);
      // if (menu_item.route_name === 'settings') {
      //   console.log('menu_item : ', menu_item);
      // }
      let show_menu = true;
      if (menu_item.meta && menu_item.meta.login === 'yes') {
        if (!this.d_user) {
          show_menu = false;
        }
      }
      // console.log('this.StoreFrontendSettings: ',this.StoreFrontendSettings)
      const cleanUrl = window.location.origin + window.location.pathname;
      if (!this.d_user && cleanUrl.startsWith("https://evideep.com")) {
        if (menu_item['component_name'] == 'user_project') {
          show_menu = false;
        }
      } 

      if (show_menu) {
        if (menu_item.meta && menu_item.meta.shop_active === 'yes') {
          if (this.StoreFrontendSettings && this.StoreFrontendSettings.data && this.StoreFrontendSettings.data.are_shop_pages_active === '1') {
            if (this.StoreFrontendSettings && this.StoreFrontendSettings.data && this.StoreFrontendSettings.data.market_visiblity_type === '0') {
              show_menu = true;
            } else if (this.StoreFrontendSettings && this.StoreFrontendSettings.data && this.StoreFrontendSettings.data.market_visiblity_type === '1') {
              if (this.d_user && this.d_user.username) {
                show_menu = true;
              } else {
                show_menu = false;
              }
            }
          } else {
            show_menu = false;
          }
        }
      }
      if (show_menu) {
        if (menu_item.meta && menu_item.meta.permission && menu_item.meta.permission.length > 0) {
          let auth_eligible = ClsUser.f_checkUserAuth(menu_item.meta.permission, 'without_id');
          show_menu = auth_eligible;
        }
      }
      if (show_menu) {
        if (menu_item.meta && menu_item.meta.add_dataset === 'yes') {
          if (this.StoreFrontendSettings && this.StoreFrontendSettings.data && this.StoreFrontendSettings.data.are_shop_pages_active === '1') {
            if (this.StoreFrontendSettings && this.StoreFrontendSettings.data && this.StoreFrontendSettings.data.market_visiblity_type === '0') {
              show_menu = true;
              if (this.StoreFrontendSettings && this.StoreFrontendSettings.data && this.StoreFrontendSettings.data.users_can_upload_dataset && this.StoreFrontendSettings.data.users_can_upload_dataset === '1') {
                show_menu = true;
              } else {
                show_menu = false;
              }
            } else if (this.StoreFrontendSettings && this.StoreFrontendSettings.data && this.StoreFrontendSettings.data.market_visiblity_type === '1') {
              if (this.d_user && this.d_user.username) {
                show_menu = true;
                if (this.StoreFrontendSettings && this.StoreFrontendSettings.data && this.StoreFrontendSettings.data.users_can_upload_dataset && this.StoreFrontendSettings.data.users_can_upload_dataset === '1') {
                  show_menu = true;
                } else {
                  show_menu = false;
                }
              } else {
                show_menu = false;
              }
            }
          } else {
            show_menu = false;
          }
        }
      }
      return show_menu;
    },
    f_styleNavbarApplicationName: function () {
      let style = '';
      style += 'cursor: pointer;';
      style += 'text-shadow: -1px -1px ' + this.StoreFrontendSettings.data.navbar_application_name_shadow_color + ';';
      style += 'font-size: 20px;';
      return style;
    },
    f_styleNavbarApplicationNameTopMenu: function () {
      let style = '';
      let application_name_color = 'rgb(14 132 134)';
      if (this.StoreFrontendSettings.data.navbar_application_name_color) {
        application_name_color = this.StoreFrontendSettings.data.navbar_application_name_color;
      }
      style += 'cursor: pointer;';
      style += 'text-shadow: -1px -1px ' + this.StoreFrontendSettings.data.navbar_application_name_shadow_color + ';';
      style += 'font-size: 22px;';
      style += 'color: ' + application_name_color + ' ;';
      style += 'font-weight: 700;';
      return style;
    },
    f_goToMainPage: function () {
      let redirect_dashboard_path = this.f_getRedirectDashboardRoute();
      // console.log('redirect_dashboard_path : ', redirect_dashboard_path);
      if (redirect_dashboard_path[0] !== '/') {
        redirect_dashboard_path = '/' + redirect_dashboard_path;
      }

      this.$router.push({ path: redirect_dashboard_path, query: {} });
      this.d_showAplicationSidebar = false;
    },
    f_logout: function () {
      this.$router.push({ 'path': '/logout', 'query': {} });
    },
    f_login: function () {
      this.$router.push({ 'path': '/login', 'query': {} });
    },
    f_calculateMenuItemStyle: function (menu_type, menu_item) {
      let route_name = '';
      try {
        route_name = menu_item.route_name[this.StoreLang];
      } catch (err) {}
      let style = '';
      // console.log('route_name       : ', route_name);
      // console.log('this.$route.name : ', this.$route.name);
      if (menu_type === 'parent') {
        style += 'color: ' + this.StoreFrontendSettings.data.menu_parent_item_text_color + ';';
        style += 'cursor: pointer;';
        style += 'min-height: 40px;';
        style += 'font-size: 17px;';
        style += 'margin: 0px;';
        style += 'padding: 5px;';
        style += 'border-bottom: solid 0.01em ' + this.StoreFrontendSettings.data.menu_parent_item_border_bottom_color + ';';
        // style += 'text-shadow: -1px -1px rgb(0, 0, 0);';
        if (this.$route.name === route_name) {
          // style = 'background-color: rgb(12, 147, 65);';
          style += 'background-color: ' + this.StoreFrontendSettings.data.menu_parent_item_background_color + ';';
        }
      } else if (menu_type === 'child') {
        style += 'color: ' + this.StoreFrontendSettings.data.menu_child_item_text_color + ';';
        style += 'cursor: pointer;';
        style += 'font-size: 15px;';
        style += 'padding: 5px;';
        style += 'min-height: 30px;';
        style += 'margin: 0px;';
        style += 'margin-left: 10px;';
        style += 'border-bottom: solid 0.01em ' + this.StoreFrontendSettings.data.menu_child_item_border_bottom_color + ';';
        // style += 'text-shadow: -1px -1px rgb(0, 0, 0);';
        if (this.$route.name === route_name) {
          // style = 'background-color: rgb(12, 147, 65);';
          style += 'background-color: ' + this.StoreFrontendSettings.data.menu_child_item_background_color + ';';
        }
      }
      return style;
    },
    f_calculateTopMenuItemStyle: function (menu_type, menu_item) {
      let route_name = '';
      try {
        route_name = menu_item.route_name[this.StoreLang];
      } catch (err) {}
      let style = '';
      // console.log('route_name       : ', route_name);
      // console.log('this.$route.name : ', this.$route.name);
      // 'cursor: pointer; border-bottom: solid 3px #05b4c5; margin: 5px; background-color: #e2f4f9;' :'cursor: pointer; margin: 5px;'
      if (menu_type === 'parent') {
        style += 'color: ' + this.StoreFrontendSettings.data.menu_parent_item_text_color + ';';
        style += 'cursor: pointer;';
        style += 'min-height: 30px;';
        style += 'margin: 10px;';
        if (this.$route.name === route_name) {
          style += 'border-bottom: solid 0.01em ' + this.StoreFrontendSettings.data.menu_parent_item_border_bottom_color + ';';
          // style += 'background-color: ' + this.StoreFrontendSettings.data.menu_parent_item_background_color + ';';
        }
      } else if (menu_type === 'child') {
        style += 'color: ' + this.StoreFrontendSettings.data.menu_child_item_text_color + ';';
        style += 'cursor: pointer;';
        style += 'font-size: 12px;';
        style += 'min-height: 30px;';
        style += 'margin: 0px;';
        if (this.$route.name === route_name) {
          style += 'border-bottom: solid 0.01em ' + this.StoreFrontendSettings.data.menu_child_item_border_bottom_color + ';';
          // style += 'background-color: ' + this.StoreFrontendSettings.data.menu_child_item_background_color + ';';
        }
      }
      return style;
    },
    f_getOptionLabel: function (option_value, options) {
      // console.log('option_value : ', option_value);
      // console.log('options : ', options);
      let option_label = '';
      for (let i in options) {
        if (options[i].value === option_value) {
          option_label = options[i].translation[this.StoreLang];
          break;
        }
      }
      return option_label;
    },
    f_calculateMainAreaStyle: function () {
      /*
        font-family: "Verdana, Sans-Serif";
        font-weight: 300;
        font-size: 24px;
      */
      let style = '';
      let page_area_text_color = 'rgb(36, 80, 90)';
      if (this.StoreFrontendSettings.data.page_area_text_color) {
        page_area_text_color = this.StoreFrontendSettings.data.page_area_text_color;
      }

      let general_font_weight = '300';
      if (this.StoreFrontendSettings.data.general_font_weight) {
        general_font_weight = this.StoreFrontendSettings.data.general_font_weight;
      }

      let general_font_size = '20';
      if (this.StoreFrontendSettings.data.general_font_size) {
        general_font_size = this.StoreFrontendSettings.data.general_font_size;
      }

      if (this.StoreFrontendSettings.data.menu_type === '0') {
        // sol menü kapalı modda.
        if (this.d_showAplicationSidebar) {
          if (this.StoreDevice && this.StoreDevice.isMobile) {
            style = 'padding: 10px; margin-left: 0px; width: 100%; background-color: white; min-height: 750px; font-weight: ' + general_font_weight + '; font-size: ' + general_font_size + 'px;';
            style += 'color: ' + page_area_text_color + ';';
          } else {
            style = 'padding: 10px; margin-left: 0px; width: 100%; background-color: white; min-height: 750px; font-weight: ' + general_font_weight + '; font-size: ' + general_font_size + 'px;';
            style += 'color: ' + page_area_text_color + ';';
            // style = 'font-family: fantasy; padding: 10px; margin-left: 325px; width: ' + (window.innerWidth - 325).toString() + 'px;';
          }
        } else {
          if (this.StoreDevice && this.StoreDevice.isMobile) {
            style = 'padding: 10px; margin-left: 0px; width: 100%; background-color: white; min-height: 750px; font-weight: ' + general_font_weight + '; font-size: ' + general_font_size + 'px;';
            style += 'color: ' + page_area_text_color + ';';
          } else {
            style = 'padding: 10px; margin-left: 0px; width: 100%; background-color: white; min-height: 750px; font-weight: ' + general_font_weight + '; font-size: ' + general_font_size + 'px;';
            style += 'color: ' + page_area_text_color + ';';
          }
        }
      } else if (this.StoreFrontendSettings.data.menu_type === '1') {
        // üst menü modu.
        if (this.d_showAplicationSidebar) {
          if (this.StoreDevice && this.StoreDevice.isMobile) {
            style = 'padding: 10px; margin-left: 0px; width: 100%; background-color: white; min-height: 750px; font-weight: ' + general_font_weight + '; font-size: ' + general_font_size + 'px;';
            style += 'color: ' + page_area_text_color + ';';
          } else {
            style = 'padding: 10px; margin-left: 0px; width: 100%; background-color: white; min-height: 750px; font-weight: ' + general_font_weight + '; font-size: ' + general_font_size + 'px;';
            style += 'color: ' + page_area_text_color + ';';
            // style = 'font-family: fantasy; padding: 10px; margin-left: 325px; width: ' + (window.innerWidth - 325).toString() + 'px;';
          }
        } else {
          if (this.StoreDevice && this.StoreDevice.isMobile) {
            style = 'padding: 10px; margin-left: 0px; width: 100%; background-color: white; min-height: 750px; font-weight: ' + general_font_weight + '; font-size: ' + general_font_size + 'px;';
            style += 'color: ' + page_area_text_color + ';';
          } else {
            style = 'padding: 10px; margin-left: 0px; width: 100%; background-color: white; min-height: 750px; font-weight: ' + general_font_weight + '; font-size: ' + general_font_size + 'px;';
            style += 'color: ' + page_area_text_color + ';';
          }
        }
      } else if (this.StoreFrontendSettings.data.menu_type === '2') {
        // sol menü modu açık.
        if (this.d_showAplicationSidebar) {
          if (this.StoreDevice && this.StoreDevice.isMobile) {
            style = 'padding: 10px; margin-left: 330px; background-color: white; min-height: 750px; font-weight: ' + general_font_weight + '; font-size: ' + general_font_size + 'px;';
            style += 'color: ' + page_area_text_color + ';';
          } else {
            style = 'padding: 10px; margin-left: 330px; background-color: white; min-height: 750px; font-weight: ' + general_font_weight + '; font-size: ' + general_font_size + 'px;';
            style += 'color: ' + page_area_text_color + ';';
            // style = 'font-family: fantasy; padding: 10px; margin-left: 325px; width: ' + (window.innerWidth - 325).toString() + 'px;';
          }
        } else {
          if (this.StoreDevice && this.StoreDevice.isMobile) {
            style = 'padding: 10px; margin-left: 0px; width: 100%; background-color: white; min-height: 750px; font-weight: ' + general_font_weight + '; font-size: ' + general_font_size + 'px;';
            style += 'color: ' + page_area_text_color + ';';
          } else {
            style = 'padding: 10px; margin-left: 0px; width: 100%; background-color: white; min-height: 750px; font-weight: ' + general_font_weight + '; font-size: ' + general_font_size + 'px;';
            style += 'color: ' + page_area_text_color + ';';
          }
        }
      }
      if (this.$route.meta.iframe_mode === 'yes') {

      } else {
        if (this.StoreDevice && this.StoreDevice.isMobile) {
          style += 'margin-top: 50px;';
        } else {
          if (['0', '2'].indexOf(this.StoreFrontendSettings.data.menu_type) !== -1) {
              style += 'margin-top: 50px;';
            } else if (this.StoreFrontendSettings.data.menu_type === '1') {
              // style += 'margin-top: 115px;';
              let h = this.f_calculateTotalMainManuCount();
              style += 'margin-top: ' + h + 'px;';
            }
        }
      }

      return style;
    },
    f_sideBarStyle: function () {
      let style = 'height: ' + (window.innerHeight - 50).toString() + 'px;';
      style += 'background-color: ' + this.StoreFrontendSettings.data.menu_background_color + ';';
      // style += 'background: linear-gradient(233deg, rgb(1 214 168) 5%, rgb(1 194 152) 10%, rgb(0 165 129) 30%, rgb(1 145 114) 50%, rgb(1 126 99) 70%, rgb(0 127 99) 80%, #00886a 95% )'
      style += 'border-bottom: solid 1px ' + this.StoreFrontendSettings.data.menu_border_bottom_color + ';';
      style += 'box-shadow: 2px 1px 2px 1px ' + this.StoreFrontendSettings.data.menu_box_shadow_color + ';';
      style += 'margin-top: 3px;';
      style += 'margin: 0px;';
      style += 'overflow-x: hidden;';
      style += 'overflow-y: auto;';
      style += 'position: fixed;';
      style += 'top: 50px;';
      style += 'width: 325px;';
      style += 'z-index: 1000;';
      // style += '::-webkit-scrollbar-track: {border-radius: 5px; background-color: rgba(170, 70, 12, 0.1);}';
      // style += '::-webkit-scrollbar: {width: 10px; background-color: rgba(170, 70, 12, 0.1);};';
      // style += '::-webkit-scrollbar-thumb: {border-radius: 100px; -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3); background-color: rgba(170, 70, 12, 0.5);}';
      return style;
    },
    f_goToContactUsPage: function () {
      this.$router.push({ 'path': '/contact', 'query': {} });
    },
    f_goToThisPage: function (menu_item) {
      // console.log('menu_item : ', menu_item);
      let is_login = '0';
      let route_path = '';
      try {
        route_path = menu_item.route_path[this.StoreLang];
      } catch (err) {}

      if (route_path) {
        if (route_path[0] !== '/') {
          route_path = '/' + route_path;
        }
        // console.log('route_path : ', route_path);
        if (this.d_user && this.d_user.username) {
          if (this.$route.path !== route_path) {
            this.$router.push({ 'path': route_path, 'query': {} });
          }
        } else {
          if (is_login === '1') {
            this.$router.push({ 'path': '/login', 'query': {} });
          } else {
            if (this.$route.path !== route_path) {
              this.$router.push({ 'path': route_path, 'query': {} });
            }
          }
        }
        if (this.StoreFrontendSettings.data.menu_type === '0') {
          //
        } else if (this.StoreFrontendSettings.data.menu_type === '1') {
          this.d_showAplicationSidebar = false;
        } else if (this.StoreFrontendSettings.data.menu_type === '2') {
          //
        }
      }
    },
    f_goToThisUrl: function (url) {
      window.open(url, '_blank');
      if (this.StoreDevice && this.StoreDevice.isMobile) {
        this.d_showAplicationSidebar = false;
      }
    },
    f_confirmStoreModal: function () {
      let data = JSON.parse(JSON.stringify(this.StoreModal.data));
      data.confirm = true;
      this.$store.commit('MutationModal', data);
      this.d_showStoreModal = false;
    },
    f_showProgressBarByInterval: function () {
      this.showProgresBarInterval = setInterval(() => {
        if (!this.d_progressData) {
          this.d_progressData = {};
        }
        if (this.d_progressData.percent === undefined) {
          this.d_progressData.percent = 5;
        } else {
          if (this.d_progressData.percent <= 50) {
            this.d_progressData.percent += 4;
          } else if (this.d_progressData.percent > 50 && this.d_progressData.percent <= 75) {
            this.d_progressData.percent += 3;
          } else if (this.d_progressData.percent > 75 && this.d_progressData.percent <= 85) {
            this.d_progressData.percent += 2;
          } else if (this.d_progressData.percent > 85 && this.d_progressData.percent < 99) {
            this.d_progressData.percent += 1;
          }
        }
        this.$forceUpdate();
      }, 500);
    },
    f_showUserName: function () {
      let result_name = '';
      if (this.d_user && this.d_user.first_name) {
        let result_name_list = [];
        let first_name = this.d_user.first_name;
        let last_name = this.d_user.last_name;
        let first_name_list = first_name.split(' ');
        for (let i in first_name_list) {
          if (parseInt(i) + 1 === first_name_list.length) {
            result_name_list.push(first_name_list[i]);
          } else {
            result_name_list.push(first_name_list[i][0]);
          }
        }
        let last_name_list = last_name.split(' ');
        for (let i in last_name_list) {
          if (parseInt(i) + 1 === last_name_list.length) {
            result_name_list.push(last_name_list[i]);
          } else {
            result_name_list.push(last_name_list[i][0]);
          }
        }
        result_name = result_name_list.join(' ');
      }
      return result_name;
    },
    f_userShopCartBundleList: function () {
      let query = 'user_client_id=' + this.d_user.username;
      let data = {};
      ServiceFunctions.user_shopcart_bundle_list(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            // alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            // we dont want to change StoreShopCartList.status. Because for every change, watch is triggered to trigger this function!!!
            // console.log('this.StoreShopCartList before mutation => ', this.StoreShopCartList);
            this.$store.commit('MutationShopCartList', { 'status': this.StoreShopCartList.status, 'data': resp.data.list });
            // console.log('this.StoreShopCartList after mutation => ', this.StoreShopCartList);
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_calculateBundleOrderCount: function () {
      let total_count = 0;
      for (let i in this.StoreShopCartOrderList.data) {
        total_count += this.StoreShopCartOrderList.data[i].bundle_list.length;
      }
      return total_count;
    },
    f_calculateShopcartBundleCount: function () {
      let total_count = 0;
      for (let i in this.StoreShopCartList.data) {
        total_count += this.StoreShopCartList.data[i].bundle_list.length;
      }
      return total_count;
    },
    f_userShopCartBundleOrderList: function () {
      let query = 'user_client_id=' + this.d_user.username;
      let data = {};
      ServiceFunctions.user_shopcart_bundle_order_list(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            // alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            // we dont want to change StoreShopCartOrderList.status. Because for every change, watch is triggered to trigger this function!!!
            // console.log('this.StoreShopCartOrderList before mutation => ', this.StoreShopCartOrderList);
            this.$store.commit('MutationShopCartOrderList', { 'status': this.StoreShopCartOrderList.status, 'data': resp.data.list });
            // console.log('this.StoreShopCartOrderList after mutation => ', this.StoreShopCartOrderList);
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },

  },
  watch: {
    'd_showStoreModal': function () {
      if (!this.d_showStoreModal) {
        this.$store.commit('MutationModalShow', false);
      }
    },
    'StoreDevice.isMobile': function () {
      console.log('this.StoreDevice.isMobile : ', this.StoreDevice.isMobile);
    },
    'd_selectedLang': function () {
      this.$store.commit('MutationLang', this.d_selectedLang);
    },
    'd_websiteEditStatus': function () {
      if (this.d_websiteEditStatus) {
        localStorage.setItem('WebsiteEdit', 'yes');
        this.$store.commit('MutationWebsiteEdit', 'yes');
      } else {
        localStorage.setItem('WebsiteEdit', 'no');
        this.$store.commit('MutationWebsiteEdit', 'no');
      }
      // console.log('StoreWebsiteEdit: ', this.StoreWebsiteEdit);
    },
    'd_selectedCurrencyType.value': function () {
      this.$store.commit('MutationCurrencyType', this.d_selectedCurrencyType);
    },
    'StoreUser.status': function () {
      console.log('this.StoreUser : ', this.StoreUser.status);
    },
    'StoreShopCartList.status': function () {
      // console.log('this.StoreShopCartList.status : ', this.StoreShopCartList.status);
      // console.log('this.StoreShopCartList : ', this.StoreShopCartList);
      this.f_userShopCartBundleList();
    },
    'StoreShopCartOrderList.status': function () {
      // console.log('this.StoreShopCartOrderList.status : ', this.StoreShopCartOrderList.status);
      // console.log('this.StoreShopCartOrderList : ', this.StoreShopCartOrderList);
      this.f_userShopCartBundleOrderList();
    },
    'StoreLoading.status': function () {
      if (this.StoreLoading.status) {
        this.d_showLoadingModal = true;
        this.d_progressData = '';
        this.f_showProgressBarByInterval();
      } else {
        this.d_showLoadingModal = false;
        this.d_progressData = '';
        clearInterval(this.showProgresBarInterval);
      }
    },
    '$route.name': function () {
      let app_title = document.getElementById('app_title');
      // console.log('this.$route : ', this.$route);
      let app_name = '';
      try {
        app_name = this.StoreFrontendSettings.data.application_name[this.StoreLang];
      } catch(err) {}
      if (app_name) {
        app_title.innerHTML = app_name + ' | ' + this.$route.path;
      } else {
        app_title.innerHTML = this.$route.path;
      }
      app_title.href = this.StoreFrontendSettings.data.navbar_middle_logo;
    },
    'StoreModal.show': function () {
      if (this.StoreModal.show) {
        this.d_showStoreModal = true;
      } else {
        this.d_showStoreModal = false;
        if (this.StoreModal.data.function_name) {
          if (this.StoreModal.data.function_name === 'f_exampleMethod' && this.StoreModal.data.confirm) {
            // this.f_exampleMethod();
          }
        }
      }
    },
    'StoreWarningCodeModal.show': function () {
      if (this.StoreWarningCodeModal.show) {
        if (this.StoreWarningCodeModal.result.block_status == '0') {
          this.d_showBlockModal = true;
          this.d_block_date = this.StoreWarningCodeModal.result['block_date'];
          this.d_block_type = this.StoreWarningCodeModal.result['block_type'];
          this.d_block_reason = this.StoreWarningCodeModal.result['block_reason'];
          this.d_block_reason_note = this.StoreWarningCodeModal.result['block_reason_note'];
        } else {
          this.d_warningCodeDb = this.StoreWarningCodeModal.result['warning_code'];
          this.d_showWarningCodeModal = true;
          setTimeout(function () {
            this.f_createCaptcha();
          }.bind(this), 1000);
        }
        this.$forceUpdate();
      }
    },
    'StoreLogout.status': function () {
      if (this.StoreLogout.status) {
        this.d_user = '';
        this.$forceUpdate();
      }
    },
    
  }
}

</script>

<style type="text/css">

  .cookies-div {
    position: fixed;
    bottom: 0px;
    right: 0px;
    z-index: 999;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    font-family: 'Inter', sans-serif;
    /*height: 200px;*/
    /*background-color: blue;*/
  }

  .chat-support-wrapper {
    position: fixed;
    bottom: -2px;
    right: 20px;
    z-index: 998;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    font-family: 'Inter', sans-serif;
  }

  .chat-toggle-button {
    background: linear-gradient(135deg, #0d6efd, #4f9cff);
    color: white;
    padding: 10px 18px;
    border-radius: 12px 12px 0px 0px;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 0.3px;
    box-shadow: 0 6px 14px rgba(0,0,0,0.15);
    transition: all 0.25s ease;
  }

  .chat-toggle-button:hover {
    background: linear-gradient(135deg, #0b5ed7, #3f8ae0);
    transform: translateY(-1px);
  }

  .open {
    border-radius: 0px;
  }

  .chat-panel {
    width: 450px;
    height: 560px;
    background: white;
    border-radius: 16px 16px 0 16px;
    overflow: hidden;
    margin-bottom: 0px;
    box-shadow: 0 12px 28px rgba(0,0,0,0.18);
    animation: slideUp 0.3s ease-out;
    position: relative;
    /*border: none;*/
    border: 3px solid #007BFF;
  }

  .panel-toggle-left {
    position: absolute;
    top: 12px;
    left: 12px;
    width: 40px;
    height: 40px;
    z-index: 2100;
    border-radius: 20%;
    padding: 6px 8px;
    background: white;
    /*box-shadow: 0 2px 8px rgba(0,0,0,0.15);*/
    /*border: none;*/
    /*transition: transform 0.2s ease;*/
  }

  .chat-sidebar-inside {
    position: absolute;
    top: 0;
    left: 0;
    width: 280px;
    height: 100%;
    background: #f8f9fa;
    box-shadow: 2px 0 12px rgba(0,0,0,0.1);
    transform: translateX(-100%);
    transition: transform 0.28s ease, opacity 0.2s ease;
    z-index: 2050;
    pointer-events: none;
    opacity: 0;
    border-radius: 0;
  }

  .chat-panel.sidebar-open .chat-sidebar-inside {
    transform: translateX(0);
    pointer-events: auto;
    opacity: 1;
  }

  .panel-content {
    height: 100%;
    padding: 20px;
    overflow-y: auto;
    background: #ffffff;
  }

  .grecaptcha-badge { 
      visibility: hidden;
  }

  .toast {
    z-index: 9999;
  }

  #search-modal .modal-dialog {
    max-width: 80vw !important;
    width: 80vw !important;
  }
  #search-modal .modal-content {
    height: 80vh !important;
  }

  .search-link {
    cursor: pointer;
  }

  .search-link:hover {
    color: blue;
  }

  /* Modal genel */
.search-modal-dialog .modal-content {
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

/* Search bar */
.search-bar-wrapper {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 15px;
  margin-bottom: 20px;
}

.search-input {
  height: 44px;
  border-radius: 10px;
}

/* Content */
.search-content {
  max-height: 55vh;
  overflow-y: auto;
  padding-right: 5px;
}

/* Result item */
.search-result-item {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  border-radius: 12px;
  transition: background-color 0.2s ease;
  cursor: pointer;
}

.search-result-item:hover {
  background-color: #f1f5f9;
}

/* Icon */
.search-result-icon {
  font-size: 24px;
  margin-right: 12px;
  color: #6c757d;
}

/* Text */
.search-result-text {
  font-weight: 500;
  flex-grow: 1;
}

.search-result-text:hover {
  text-decoration: underline;
}

/* External link */
.search-result-external {
  color: #0d6efd;
}


/* Modal header genel */
#search-modal .modal-header {
  background: linear-gradient(135deg, #0d6efd, #4dabf7);
  color: #fff;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  justify-content: center; /* başlığı ortala */
  position: relative;
}

/* Title (Ara yazısı) */
#search-modal .modal-title {
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  width: 100%;
}

.search-from-row {
  margin-bottom: 8px;
}

.search-toggle {
  background: transparent;
  border: 1px solid gray;
  color: gray;
  border-radius: 20px;
  padding: 6px 14px;
  margin-right: 8px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
}

/* Hover */
.search-toggle:hover {
  opacity: 0.8;
}

/* AKTİF ORTAK */
.search-toggle.active {
  opacity: 1;
  /*font-weight: 600;*/
}

/* TYPE BAZLI RENKLER */
.search-toggle.profile.active {
  border-color: #28a745;
  color: white;
  background-color: #28a745;
}

.search-toggle.bundle.active {
  border-color: #fd7e14;
  color: white;
  background-color: #fd7e14;
}

.search-toggle.webunit.active {
  border-color: #007bff;
  color: white;
  background-color: #007bff;
}

/* PASİF */
.search-toggle:not(.active) {
  opacity: 0.7;
}

</style>

